import { Component, OnInit, AfterViewInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { DatePipe } from "@angular/common";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MatDialog } from "@angular/material/dialog";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Config } from "src/app/app-constant";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ToastrService } from 'ngx-toastr'
import { every, first } from "rxjs";

import { EncryptionService } from "src/app/service/encryption/encryption.service";
import { HttpService } from "src/app/service/http/http.service";
import { LoaderService } from "src/app/service/loader/loader.service";
import { SharedService } from "src/app/service/shared/shared.service";
import { DownloadAsPdfService } from "src/app/service/downloadAspdf/download-as-pdf.service";

import { ConfirmationPopupComponent } from "src/app/shared/popups/confirmation-popup/confirmation-popup.component";
import { ExtendDueDatePopupComponent } from "src/app/shared/popups/extend-due-date-popup/extend-due-date-popup.component";
import { DwmdashbordCountPopUpComponent } from "src/app/shared/popups/dwmdashbord-count-pop-up/dwmdashbord-count-pop-up.component";

import * as saveAs from "file-saver";
import * as Highcharts from "highcharts";
import * as moment from "moment";
import * as echarts from 'echarts';

import { environment } from 'src/environments/environment';
import { MobileResponsiveService } from "src/app/services/mobile-view/mobile-responsive.service";

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-task-managements',
  templateUrl: './task-managements.component.html',
  styleUrls: ['./task-managements.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class TaskManagementsComponent implements OnInit {

  loggedInUserId: any;
  loggedInUserRole: any;
  searchString: any = null;
  loggedInUserCompanyID: any;
  selectedTypeTabIndex = 0;
  selectedSubTabIndex = 0;
  selectedTypeTabName = 'Review Meeting'
  buttonColorName: any;
  subModuleButtonColor: any;
  selectedSubTab: any = 'Dashboard';
  selectedSizeOfTask: any = 25;
  searchTaskString: any = null;
  taskStatusList = [
    { id: "NotStarted", name: 'Not Started' },
    { id: "Completed", name: 'Completed' },
    { id: "PartiallyCompleted", name: 'Partially Completed' },
    { id: "IncompleteAndEXPD", name: 'Incomplete & EXPD' }
  ];
  taskStatusListDWM = [
    { id: "Completed", name: 'Completed' },
    { id: "InCompleted", name: 'Incompleted' },
  ];
  dropdownSettings: IDropdownSettings = {};
  selectedTaskStatus: any = [];
  taskFromDate: any = null;
  taskToDate: any = null;
  taskColumnHeaderInfoData: any = [];
  dwmColumnHeaderInfoData: any = [];
  taskList: any = [];
  isEditIndexTask: any;
  selectAllTaskCheckbox: boolean = false;
  selectedTaskList: any = [];
  getIndirectEmployees: any = [];
  hideDeleteButton: boolean = true;
  page: any = 0;
  currentPageNumber: any = 1;
  totalTaskPages: any = 0;
  totalTaskCount: any;
  selectedEmployeeId: any = null;
  selectedFrequencyId = 1;
  getAllEmployeeofCompany: any;
  skipDate: any;
  dailyTeamTaskFromDate = new Date();
  reportOf = [{ id: 'My Task', name: 'My Task' },
  { id: 'Assign a Task', name: 'Assign a Task' }
  ]
  selectedReportOf: any = 'My Task';
  selectedEmployeeIdForReport: any = [];
  showAddNewSaveBtn: boolean = false;
  todaysDate = new Date();
  showingCount: any = 1;
  showingOfCount: any = 0;
  previousPageTotalCount: any = 0;
  myDWMCount: any = 0;;
  teamDWMCount: any = 0;
  assignedTaskCount: any = 0;
  myTaskCount: any = 0;
  selectedMultiEmployeeId: any = [];
  selectedMultiEmployeeIdForDashboard: any = [];
  selectedEmpIdForDashboard: any = null;
  highcharts: typeof Highcharts = Highcharts;
  getTaskedAssignedByMeData: any = [];
  getTaskedAssignedByToData: any = [];
  getEmployeeWiseTaskStatusDataForBar: any = [];
  getEmployeeWiseTaskStatusDataForPie: any = [];
  dashboardCounterModule = [
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'No. of days in the period',
      totalCount: 0,
      color: '#3067FA',
      background: '#D4DBEB',
    },
    {
      moduleActiveIcon: '././assets/icon/managerApprove.svg',
      ModuleName: 'No. of Days Skipped',
      totalCount: 0,
      color: '#F3820E',
      background: '#FFE3C3',
    },
    {
      moduleActiveIcon: '././assets/icon/goalSetting.svg',
      ModuleName: 'Days of DWM Reviewed',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'Days of DWM to be Reviewed',
      totalCount: 0,
      color: '#2D82D7',
      background: '#CEDEEE',
    }
  ]
  employeeWiseTaskStatusData: any = [];
  employeeExtentionWiseTasksData: any = [];
  getComingWeekwiseData: any = [];
  allocatedTasksData: any = [];
  getEmployeeWiseDWMTaskStatus: any = [];
  taskAssignedByMeFromDate: any = null;
  taskAssignedByMeToDate: any = null;
  taskAssignedToMeFromDate: any = null;
  taskAssignedToMeToDate: any = null;
  employeeStatusFromDate: any = null;
  employeeStatusToDate: any = null;
  employeeTaskFromDate: any = null;
  employeeTaskToDate: any = null;
  employeeExtentionFromDate: any = null;
  employeeExtentionToDate: any = null;
  myComingWeekTaskFromDate: any = null;
  myComingWeekTaskToDate: any = null;
  allocatedTaskFromDate: any = null;
  allocatedTaskToDate: any = null;
  selectedEmpIdForEmpWiseTaskStatus: any = null;
  selectedEmpIdForEmpWiseTask: any = null;
  selectedEmpIdForEmpWiseTaskWithExtention: any = null;
  showEmpWiseStatusTble: boolean = false;
  empWiseTaskStatusGraphType: any = 'bar';
  chartEmpTaskStatus: echarts.ECharts | undefined;
  chartOptionsEmpTaskStatus: any = {
    bar: {},
    pie: {},
  };
  dwmEmpWiseTaskStatusData: any = null;
  selectedEmpIdForDWMEmpWiseTaskStatus: any = null;
  dwmEmpWiseTaskStatusFormDate: any = null;
  dwmEmpWiseTaskStatusToDate: any = null;
  selectedEmpIdForDWMEmpCompletionStatus: any = null;
  dwmCompletionStatusFormDate: any = null;
  dwmCompletionStatusToDate: any = null;
  selectedDWMTaskStatus: any = null;
  dwmTaskStatusList: any[] = [];
  dWMReportTaskList: any[] = [];
  maxDate: any;
  minDate: any;
  selectedIdForDWMCount: any;
  isUserEmployee: boolean = false;
  completedTaskStatusCount: any = 0;
  taskIsReviewByEmployee: boolean = false;
  loggedInUserRoleIsMD: any;

  frequency = [
    { id: 1, frequency: 'DAILY' },
    { id: 2, frequency: 'ALTERNATE_DAY' },
    { id: 3, frequency: 'WEEKLY' },
    { id: 4, frequency: 'FORTNIGHT' },
    { id: 5, frequency: 'MONTHLY' },

  ];


  constructor(public sharedService: SharedService, public toastr: ToastrService,
    private loader: LoaderService, private encryptionService: EncryptionService,
    private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private pdfDownload: DownloadAsPdfService, public mobileResponsiveService: MobileResponsiveService) { }

  ngOnInit() {
    this.selectedTaskStatus = this.taskStatusList;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInUserId = Number(sessionStorage.getItem('loggedInUserId'));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoleIsMD = sessionStorage.getItem('loggedInUserIsMD');

    const currentDate = new Date();
    this.dailyTeamTaskFromDate = currentDate
    const firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    let startOfWeek: any = moment().clone().startOf('week');
    let endOfWeek: any = moment().clone().endOf('week');
    let startOfNextWeek: any = moment().clone().add(1, 'week').startOf('week');
    let endOfNextWeek: any = moment().clone().add(1, 'week').endOf('week');
    this.maxDate = lastDay;
    this.minDate = firstDay;
    this.taskFromDate = firstDay;

    this.taskToDate = lastDay;
    this.taskAssignedByMeFromDate = firstDay;
    this.taskAssignedByMeToDate = lastDay;
    this.taskAssignedToMeFromDate = firstDay;
    this.taskAssignedToMeToDate = lastDay;
    this.employeeStatusFromDate = firstDay;
    this.employeeStatusToDate = lastDay;
    this.employeeTaskFromDate = firstDay;
    this.employeeTaskToDate = lastDay;
    this.employeeExtentionFromDate = firstDay;
    this.employeeExtentionToDate = lastDay;
    this.myComingWeekTaskFromDate = new Date(startOfNextWeek);
    this.myComingWeekTaskToDate = new Date(endOfNextWeek);;
    this.allocatedTaskFromDate = new Date(startOfWeek);
    this.allocatedTaskToDate = new Date(endOfWeek);
    this.dwmEmpWiseTaskStatusFormDate = firstDay;
    this.dwmEmpWiseTaskStatusToDate = lastDay;
    this.dwmCompletionStatusFormDate = firstDay;
    this.dwmCompletionStatusToDate = currentDate;
    this.selectedIdForDWMCount = this.loggedInUserId


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    //Graphs
  }

  ionViewWillEnter() {
    this.activatedroute.params.subscribe((params: any) => {
      var tab = params['tab'];
      var index = params['index'];
      var subTab = params['subTab'];
      var fromDate = params['formDate'];
      var toDate = params['toDate'];
      var currentDate = params['currentDate']

      if (params['tab'] && params['subTab']) {
        this.selectedTypeTabName = tab;
        this.selectedTypeTabIndex = index;
        this.selectedSubTab = subTab;
        this.taskFromDate = new Date(fromDate) || null;
        this.taskToDate = new Date(toDate) || null;
        this.dailyTeamTaskFromDate = new Date(currentDate) || null;
        this.onClickSubTab(this.selectedSubTab);
      };
    })
    if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      this.getAllEmployeeDropdownByCompanyID();
    } else if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      this.getIndirectEmployeesList();
    } else if (this.loggedInUserRole == 'Employee') {
      this.isUserEmployee = true;
      this.selectedEmpIdForDashboard = this.loggedInUserId;
      this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId,
        this.selectedEmpIdForEmpWiseTask = this.loggedInUserId,
        this.selectedEmpIdForEmpWiseTaskWithExtention = this.loggedInUserId;
      this.selectedEmpIdForDWMEmpWiseTaskStatus = this.loggedInUserId;
      this.selectedEmpIdForDWMEmpCompletionStatus = this.loggedInUserId;
    } else if (this.loggedInUserRole == 'Admin') {
      this.getEmployeeOfAdmin()
    }
    this.getCountOfTasks();
    this.getCountOfDWMWorkTasks();
    this.getCountOfMyDailyWork();
    this.getDWMTaskActionableList();

    //Graphs
    setTimeout(() => {
      this.taskAssignedByMeFunction();
      this.taskAssignedToMeFunction();
      this.getEmployeeWiseTaskStatus();
      this.getEmployeeWiseTask();
      this.getEmployeeWiseTasksWithExtensions();
      this.getAllocatedWeekTasksInWeek();
      this.getComingWeekTasks();
      this.getDWMEmployeeWiseTaskStatus();
      this.getcountOfEmployeeWiseTaskCompletionStatus();
    }, 1000)

  }


  // ==================== For the Formating Frequency from Uppercase to lowercase ============================

  formatFrequency(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, char => char.toUpperCase());
  }

  gotToImport() {
    this.router.navigate(['/home/hrportal/importFiles', { module: 'importDWM' }]);
  }

  tabTypeChanged(event: MatTabChangeEvent): void {
    this.activatedroute.params.subscribe((params: any) => {

      var tab = params['tab'];
      var index = params['index']
      var subTab = params['subTab']
      var fromDate = params['formDate']
      var toDate = params['toDate']
      if (params['tab'] && params['subTab']) {
        this.selectedTypeTabName = tab
        this.selectedTypeTabIndex = index
        this.selectedSubTab = subTab;
        this.taskFromDate = fromDate;
        this.taskToDate = toDate;
      } else {
        this.selectedTypeTabName = event.tab.textLabel;
        this.selectedTypeTabIndex = event?.index;
        this.selectedSubTab = 'Dashboard';
        this.selectedSubTabIndex = event?.index;
      }
    })

    this.taskList = [];
    this.showAddNewSaveBtn = false;
    this.selectedSizeOfTask = 25;
    this.page = 0;
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.initilaizeTaskColumn();
      this.reportOf = [{ id: 'My Task', name: 'My Task' },
      { id: 'Assign a Task', name: 'Assign a Task' }
      ]
      this.selectedReportOf = 'My Task';
      this.taskAssignedByMeFunction();
      this.taskAssignedToMeFunction();
    } else {
      this.initilaizeDWMColumn();
      this.reportOf = [{ id: 'My DWM', name: 'My DWM' },
      { id: 'Team DWM', name: 'Team DWM' }
      ]
      this.selectedReportOf = 'My DWM'
      this.getCountOfMyDailyWork();
    }
    this.onClickSubTab(this.selectedSubTab)
  }



  onClickSubTab(subTabName: any) {
    this.selectedSubTab = subTabName;
    this.taskList = [];
    this.getIndirectEmployees = [];
    this.selectedEmployeeId = null;
    this.selectedMultiEmployeeId = [];
    this.selectedEmployeeIdForReport = [];
    this.selectAllTaskCheckbox = false;
    this.selectedTaskList = [];
    this.isEditIndexTask = null;
    this.selectedEmpIdForDWMEmpWiseTaskStatus = null;
    this.selectedEmpIdForDWMEmpCompletionStatus = null;
    //  this.selectedEmpIdForDashboard = null;
    this.selectedEmpIdForDWMEmpCompletionStatus = null;
    this.showAddNewSaveBtn = false;
    this.selectedSizeOfTask = 25;
    this.page = 0;
    this.isTaskSubmitted = false;
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.selectedTaskStatus = this.taskStatusList;
      if (this.selectedSubTab == 'Employee Task') {
        this.initilaizeTaskColumn();
        if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        } else {
          this.getAllEmployeeDropdownByCompanyID();
        }
        this.getCountOfTasks();
      }
      if (this.selectedSubTab == 'My Task') {
        this.initilaizeTaskColumn();

        this.getCountOfTasks();
        this.getAllTasks();
      }
      if (this.selectedSubTab == 'Assign a Task') {
        this.initilaizeTaskColumn();
        this.getIndirectEmployeesList();
        this.getCountOfTasks();
        this.getAllTasks();
      }
      if (this.selectedSubTab == 'Reports') {
        this.selectedReportOf = 'My Task'
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.getAllEmployeeDropdownByCompanyID();
        } else if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        } else {
          this.taskManagmentReport();
        }
        this.initilaizeTaskColumn();
      }
      if (this.selectedSubTab == 'Dashboard') {
        this.taskAssignedByMeFromDate = this.taskFromDate;
        this.taskAssignedByMeToDate = this.taskToDate;
        this.taskAssignedToMeFromDate = this.taskFromDate;
        this.taskAssignedToMeToDate = this.taskToDate;
        this.employeeStatusFromDate = this.taskFromDate;
        this.employeeStatusToDate = this.taskToDate;
        this.employeeTaskFromDate = this.taskFromDate;
        this.employeeTaskToDate = this.taskToDate;
        this.employeeExtentionFromDate = this.taskFromDate;
        this.employeeExtentionToDate = this.taskToDate;
        this.myComingWeekTaskFromDate = this.taskFromDate;
        this.myComingWeekTaskToDate = this.taskToDate;
        this.allocatedTaskFromDate = this.taskFromDate;
        this.allocatedTaskToDate = this.taskToDate;
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.getAllEmployeeDropdownByCompanyID();
          this.getCountOfTasks();
        }
        if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        }
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          this.getIndirectEmployeesList();
        }
        this.taskAssignedByMeFunction();
        this.taskAssignedToMeFunction();
        this.getEmployeeWiseTaskStatus()
        this.getEmployeeWiseTask();
        this.getEmployeeWiseTasksWithExtensions();
        this.getAllocatedWeekTasksInWeek();
        this.getComingWeekTasks();

      }
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      this.selectedTaskStatus = this.taskStatusListDWM
      if (this.selectedSubTab == 'Employee DWM') {
        this.initilaizeDWMColumn();
        if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        } else {
          this.getAllEmployeeDropdownByCompanyID();
        }
        this.getCountOfMyDailyWork();
      }
      if (this.selectedSubTab == 'My DWM') {
        this.initilaizeDWMColumn();
        this.getAllDWMTasks();
        this.skipDayManagerComment();
        this.getCountOfMyDailyWork();
      }
      if (this.selectedSubTab == 'Team DWM') {
        this.initilaizeDWMColumn();
        this.getTeamOfManager();
        setTimeout(() => {
          this.getAllDWMTasks();
          this.getCountOfDWMWorkTasks();
          //  Ensure employee and data are loaded
          if (this.isCheckSelectedDateIsTodaysDate && this.selectedEmployeeId) {
            this.skipDayManagerComment();
          }
        }, 1000)

      }
      if (this.selectedSubTab == 'Reports') {
        this.selectedReportOf = 'My DWM'
        this.initilaizeDWMColumn();
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.getIndirectEmployeesList();
          this.getCountOfDWMWorkTasks();
        }
        else if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        }
        else {
          this.taskManagmentReport();
        }
      }
      if (this.selectedSubTab == 'Dashboard') {
        this.dwmEmpWiseTaskStatusFormDate = this.taskFromDate;
        this.dwmEmpWiseTaskStatusToDate = this.taskToDate;
        this.dwmCompletionStatusFormDate = this.taskFromDate;
        this.dwmCompletionStatusToDate = new Date();
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.getAllEmployeeDropdownByCompanyID();
        }
        if (this.loggedInUserRole == 'Admin') {
          this.getEmployeeOfAdmin()
        }
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          this.getTeamOfManager();
        }
        this.dwmDashboardCounts();
        this.getCountOfDWMWorkTasks();
        this.getDWMTaskActionableList();
        // if(this.selectedTypeTabName !== 'Daily Work Management'){

        //   this.getDWMEmployeeWiseTaskStatus()
        // }
        this.getcountOfEmployeeWiseTaskCompletionStatus();
      }
    }
  }
  onSelectSizeCount() {
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
    }
  }
  onSearchTask(searchString: any) {
    var search = ''
    this.searchString = searchString;
    if (searchString == '') {
      this.searchString = null;
      if (this.selectedTypeTabName == 'Review Meeting') {
        if (this.selectedSubTab == 'Reports') {
          this.taskManagmentReport();
        } else {
          this.getCountOfTasks();
          this.getAllTasks();
        }
      }
      if (this.selectedTypeTabName == 'Daily Work Management') {
        if (this.selectedSubTab == 'Reports') {
          this.taskManagmentReport();
        } else {
          this.getCountOfMyDailyWork();
          this.getCountOfDWMWorkTasks();
          this.getAllDWMTasks();
        }
      }
      return;
    }
    if (searchString.length > 1) {
      setTimeout(() => {
        search = searchString;
        if (search.length == searchString.length) {
          setTimeout(() => {
            if (this.selectedTypeTabName == 'Review Meeting') {
              if (this.selectedSubTab == 'Reports') {
                this.taskManagmentReport();
              } else {
                this.getCountOfTasks();
                this.getAllTasks();
              }
            }
            if (this.selectedTypeTabName == 'Daily Work Management') {
              if (this.selectedSubTab == 'Reports') {
                this.taskManagmentReport();
              } else {
                this.getCountOfMyDailyWork();
                this.getCountOfDWMWorkTasks();
                this.getAllDWMTasks();
              }
            }
          },
            500);
        }
      },
        1500);
    }
  }
  onSelectFilterStatus() {
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
      this.skipDayManagerComment();
    }
  }
  selectAllStatus(event: any) {
    this.selectedTaskStatus = event;
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
      this.skipDayManagerComment();
    }
  }
  onDeSelectAllStatus() {
    this.selectedTaskStatus = [];
    this.taskList = [];
    // if (this.selectedTypeTabName == 'Review Meeting') {
    //   this.getCountOfTasks();
    //   this.getAllTasks();
    // }
    // if (this.selectedTypeTabName == 'Daily Work Management') {
    //   this.getCountOfDWMWorkTasks();
    //   this.getAllDWMTasks();
    // }
  }
  onDateChange() {
    if (this.taskFromDate != null && this.taskToDate != null) {
      if (this.selectedTypeTabName == 'Review Meeting') {
        if (this.selectedSubTab == 'Reports') {
          this.taskManagmentReport();
        } else {
          if (this.loggedInUserRole == 'Admin') {
            this.getEmployeeOfAdmin()
          } else {
            this.getIndirectEmployeesList();
          }
          this.getCountOfTasks();
          this.getAllTasks();
        }
      }
      if (this.selectedTypeTabName == 'Daily Work Management') {
        if (this.selectedSubTab != 'Reports') {
          this.getCountOfMyDailyWork();
          this.getCountOfDWMWorkTasks();
          this.getAllDWMTasks();
          this.skipDayManagerComment();
        }
      }
    } else {
      this.taskList = [];
    }
  }
  // onFormDateChangeDWM(event: any) {
  //   this.taskToDate = null;
  //   this.dWMReportTaskList = [];
  //   this.selectedEmployeeIdForReport = []
  //   let date = new Date(event.value)
  //   if (date && this.taskFromDate) {
  //     date.setDate(date.getDate() + 31);
  //     this.minDate = new Date(event.value)
  //     this.maxDate = date;
  //     // this.taskManagmentReport();
  //   }
  // }
  // onToDateChangeDWM(event: any) {
  //   let date = new Date(event.value)
  //   if (date && this.taskToDate) {
  //     date.setDate(date.getDate() - 31)
  //     this.minDate = date;
  //     this.maxDate = new Date(event.value)
  //     this.getIndirectEmployeesList();
  //   }
  // }


  onFormDateChangeDWM(event: any) {
    this.taskToDate = null;
    this.dWMReportTaskList = [];
    this.selectedEmployeeIdForReport = [];
    let fromDate = new Date(event.value);
    if (fromDate && this.taskFromDate) {
      const toDate = this.taskToDate ? new Date(this.taskToDate) : null;
      const sameDay = toDate && toDate.toDateString() === fromDate.toDateString();
      const monthBoundary = toDate && this.isMonthBoundary(fromDate, toDate);
      if (sameDay || monthBoundary) {
        this.minDate = fromDate;
        this.maxDate = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
        return;
      }
      let maxD = new Date(fromDate);
      maxD.setDate(maxD.getDate() + 31);
      this.minDate = fromDate;
      this.maxDate = maxD;
    }
  }

  onToDateChangeDWM(event: any) {
    let date = new Date(event.value);
    if (date && this.taskToDate) {
      const fromDate = new Date(this.taskFromDate);
      const toDate = date;
      const sameDay = fromDate.toDateString() === toDate.toDateString();
      const monthBoundary = this.isMonthBoundary(fromDate, toDate);
      if (sameDay || monthBoundary) {
        this.minDate = fromDate;
        this.maxDate = new Date(toDate.getFullYear(), toDate.getMonth() + 1, 0);
        this.getIndirectEmployeesList();
        return;
      }
      let minD = new Date(toDate);
      minD.setDate(minD.getDate() - 31);
      this.minDate = minD;
      this.maxDate = toDate;
      this.getIndirectEmployeesList();
    }
  }



  isMonthBoundary(fromDate: Date, toDate: Date): boolean {
    const nextDay = new Date(fromDate);
    nextDay.setDate(fromDate.getDate() + 1);
    return nextDay.toDateString() === toDate.toDateString();
  }


  initilaizeTaskColumn() {
    this.taskColumnHeaderInfoData = [];
    this.taskColumnHeaderInfoData.push({ label: 'Actionable', propertyName: 'actionable', sortingName: 'actionable', isMandatory: true });
    if (this.selectedSubTab == 'Employee Task' || this.selectedSubTab == 'My Task' || this.selectedSubTab == 'Reports') {
      this.taskColumnHeaderInfoData.push({ label: 'Assigned By', propertyName: 'firstName', sortingName: 'managerId.firstName', isMandatory: false });
    }
    if (this.selectedSubTab == 'Employee Task' || this.selectedSubTab == 'Assign a Task' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'Assign a Task')
      || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      this.taskColumnHeaderInfoData.push({ label: 'Assigned To', propertyName: 'firstName', sortingName: 'employeeId.firstName', isMandatory: true });
    }
    this.taskColumnHeaderInfoData.push({ label: 'Start Date', propertyName: 'startDate', sortingName: 'startDate', isMandatory: true });
    this.taskColumnHeaderInfoData.push({ label: 'End Date', propertyName: 'byWhen', sortingName: 'byWhen', isMandatory: true });
    this.taskColumnHeaderInfoData.push({ label: 'Extension #1', propertyName: 'extension1', sortingName: 'extendDate1', isMandatory: false });
    this.taskColumnHeaderInfoData.push({ label: 'Extension #2', propertyName: 'extension2', sortingName: 'extendDate2', isMandatory: false });
    this.taskColumnHeaderInfoData.push({ label: 'Extension #3', propertyName: 'extension3', sortingName: 'extendDate3', isMandatory: false });
    this.taskColumnHeaderInfoData.push({ label: 'Status', propertyName: 'taskStatus', sortingName: 'taskStatus', isMandatory: true });
    this.taskColumnHeaderInfoData.push({ label: '% of Task Comp.', propertyName: 'percentageTaskCompletion', sortingName: 'percentageTaskCompletion', isMandatory: false });
    this.taskColumnHeaderInfoData.push({ label: 'Employee Comment', propertyName: 'employeeComment', sortingName: 'employeeComment', isMandatory: false });
    this.taskColumnHeaderInfoData.push({ label: 'Reporting Manager Comment', propertyName: 'reportingManagerComment', sortingName: 'reportingManagerComment', isMandatory: false });
  }
  initilaizeDWMColumn() {
    this.dwmColumnHeaderInfoData = [];
    if (this.selectedSubTab == 'Reports') {
      this.dwmColumnHeaderInfoData.push({ label: 'Date', propertyName: 'date', sortingName: 'date', isMandatory: false });
    }
    this.dwmColumnHeaderInfoData.push({ label: 'Actionable', propertyName: 'actionable', sortingName: 'actionable', isMandatory: true });
    if (this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'My DWM') ||
      this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      this.dwmColumnHeaderInfoData.push({ label: 'Assigned By', propertyName: 'firstName', sortingName: 'managerId.firstName', isMandatory: false });
    }
    if (this.selectedSubTab == 'Employee DWM' || (this.selectedSubTab == 'Reports' && this.selectedReportOf == 'Team DWM')
      || this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      this.dwmColumnHeaderInfoData.push({ label: 'Assigned To', propertyName: 'firstName', sortingName: 'employeeId.firstName', isMandatory: false });
    }
    this.dwmColumnHeaderInfoData.push({ label: 'Status', propertyName: 'taskStatus', sortingName: 'dwmStatus', isMandatory: true });
    // this.dwmColumnHeaderInfoData.push({ label: '% of Task Comp.', propertyName: 'percentageTaskCompletion', sortingName: 'percentageTaskCompletion', });
    this.dwmColumnHeaderInfoData.push({ label: 'Employee Comment', propertyName: 'employeeComment', sortingName: 'employeeComment', isMandatory: false });
    this.dwmColumnHeaderInfoData.push({ label: 'Reporting Manager Comment', propertyName: 'reportingManagerComment', sortingName: 'reportingManagerComment', isMandatory: false });
    this.dwmColumnHeaderInfoData.push({ label: 'Doc. Attachment', propertyName: 'documentAttachment', sortingName: 'documentAttachment', isMandatory: false });
    this.dwmColumnHeaderInfoData.push({ label: 'Is this a Fixed Task?', propertyName: 'fixedTask', sortingName: 'fixedTask', isMandatory: false });
    this.dwmColumnHeaderInfoData.push({ label: 'Frequency', propertyName: 'frequency', sortingName: 'frequency', isMandatory: false });
  }
  sortName: any = 'id';
  sortBy: any = 'asc'
  onSortAssending(name: any) {
    this.sortName = name;
    this.sortBy = 'asc';
    if (this.selectedTypeTabName == 'Review Meeting') {
      var ids = [];
      var userType = 1;
      if (this.selectedSubTab == 'My Task') {
        ids.push(this.loggedInUserId);
        userType = 1;
      } else if (this.selectedSubTab == 'Employee Task') {
        ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
        userType = 1;
      }
      else {
        ids.push(this.loggedInUserId)
        userType = 2;
      }
      if (this.taskFromDate != null && this.taskToDate != null) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "employeeId": ids,
          "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
          "search": this.searchString,
          "taskStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
          "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
          "userType": userType
        }
        this.httpService.callPostService(this.config.getAllTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask + '&sort=' + name + ',asc', request).subscribe((data: any) => {
          this.taskList = [];
          this.currentPageNumber = data?.data?.currentPageNumber + 1;
          this.totalTaskCount = data?.data?.total;
          this.totalTaskPages = data?.data?.totalPages;
          data.data?.setresponses?.forEach((ele: any) => {
            let obj = {
              assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
              actionable: ele.actionable,
              byWhen: this.datePipe.transform(ele.byWhen, 'yyyy-MM-dd'),
              companyId: ele.companyId,
              employeeComment: ele.employeeComment,
              employeeId: ele.employeeId?.id,
              extendDate1: ele.extendDate1,
              extendDate2: ele.extendDate2,
              extendDate3: ele.extendDate3,
              id: ele.id,
              managerId: ele.managerId?.id,
              percentageTaskCompletion: ele.percentageTaskCompletion,
              reportingManagerComment: ele.reportingManagerComment,
              startDate: this.datePipe.transform(ele.startDate, 'yyyy-MM-dd'),
              taskStatus: ele.taskStatus,
              empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName
            }
            this.taskList.push(obj)
          });
          this.paginationCountData();
        })
      }
    } else {
      var ids = [];
      var userType = 1;
      if (this.selectedSubTab == 'My DWM') {
        ids.push(this.loggedInUserId);
        userType = 1;
      } else if (this.selectedSubTab == 'Employee DWM') {
        ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
        userType = 1;
      }
      else {
        console.log(this.selectedEmpIdForDashboard);

        let newId = this.selectedEmployeeId || this.selectedEmpIdForDashboard
        ids.push(newId)
        userType = 2;
      }
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
        "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
        "userType": userType
      }
      this.httpService.callPostService(this.config.getDWMTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask + '&sort=' + name + ',asc', request).subscribe((data: any) => {
        this.taskList = [];
        this.currentPageNumber = data?.data?.currentPageNumber + 1;
        this.totalTaskCount = data?.data?.total;
        this.totalTaskPages = data?.data?.totalPages;
        this.taskIsReviewByEmployee = data.data?.dailyWorkManagement?.some((ele: any) => ele.isReviewed);
        data.data?.dailyWorkManagement?.forEach((ele: any, index: any) => {
          let obj = {
            assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
            actionable: ele.actionable,
            companyId: ele.companyId,
            documentAttachment: ele.documentAttachment,
            documentName: ele.documentName,
            employeeComment: ele.employeeComment,
            employeeId: ele.employeeId?.id,
            fixedTask: ele.fixedTask,
            frequency: ele.frequency,
            id: ele.id,
            managerId: ele.managerId?.id,
            reportingManagerComment: ele.reportingManagerComment,
            startDate: ele.startDate,
            taskStatus: ele.dwmStatus,
            empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName,
            taskStatusFlag: ele.dwmStatus == 'Completed' ? true : false,
            index: index
          }
          this.taskList.push(obj)
        });
        this.completedTaskStatusCount = this.taskList?.filter((item: { taskStatus: string; }) => item.taskStatus === 'Completed').length;
        this.paginationCountData();
      })
    }
  }
  onSortDesending(name: any) {
    this.sortName = name;
    this.sortBy = 'desc';
    if (this.selectedTypeTabName == 'Review Meeting') {
      var ids = [];
      var userType = 1;
      if (this.selectedSubTab == 'My Task') {
        ids.push(this.loggedInUserId);
        userType = 1;
      } else if (this.selectedSubTab == 'Employee Task') {
        ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
        userType = 1;
      }
      else {
        ids.push(this.loggedInUserId)
        userType = 2;
      }
      if (this.taskFromDate != null && this.taskToDate != null) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "employeeId": ids,
          "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
          "search": this.searchString,
          "taskStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
          "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
          "userType": userType
        }
        this.httpService.callPostService(this.config.getAllTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask + '&sort=' + name + ',desc', request).subscribe((data: any) => {
          this.taskList = [];
          this.currentPageNumber = data?.data?.currentPageNumber + 1;
          this.totalTaskCount = data?.data?.total;
          this.totalTaskPages = data?.data?.totalPages;
          data.data?.setresponses?.forEach((ele: any) => {
            let obj = {
              assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
              actionable: ele.actionable,
              byWhen: this.datePipe.transform(ele.byWhen, 'yyyy-MM-dd'),
              companyId: ele.companyId,
              employeeComment: ele.employeeComment,
              employeeId: ele.employeeId?.id,
              extendDate1: ele.extendDate1,
              extendDate2: ele.extendDate2,
              extendDate3: ele.extendDate3,
              id: ele.id,
              managerId: ele.managerId?.id,
              percentageTaskCompletion: ele.percentageTaskCompletion,
              reportingManagerComment: ele.reportingManagerComment,
              startDate: this.datePipe.transform(ele.startDate, 'yyyy-MM-dd'),
              taskStatus: ele.taskStatus,
              empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName
            }
            this.taskList.push(obj)
          });
          this.paginationCountData();
        })
      }
    } else {
      var ids = [];
      var userType = 1;
      if (this.selectedSubTab == 'My DWM') {
        ids.push(this.loggedInUserId);
        userType = 1;
      } else if (this.selectedSubTab == 'Employee DWM') {
        ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
        userType = 1;
      }
      else {
        let newId = this.selectedEmployeeId || this.selectedEmpIdForDashboard
        ids.push(newId)
        userType = 2;
      }
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
        "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
        "userType": userType
      }
      this.httpService.callPostService(this.config.getDWMTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask + '&sort=' + name + ',desc', request).subscribe((data: any) => {
        this.taskList = [];
        this.currentPageNumber = data?.data?.currentPageNumber + 1;
        this.totalTaskCount = data?.data?.total;
        this.totalTaskPages = data?.data?.totalPages;
        this.taskIsReviewByEmployee = data.data?.dailyWorkManagement?.some((ele: any) => ele.isReviewed);
        data.data?.dailyWorkManagement?.forEach((ele: any, index: any) => {
          let obj = {
            assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
            actionable: ele.actionable,
            companyId: ele.companyId,
            documentAttachment: ele.documentAttachment,
            documentName: ele.documentName,
            employeeComment: ele.employeeComment,
            employeeId: ele.employeeId?.id,
            fixedTask: ele.fixedTask,
            frequency: ele.frequency,
            id: ele.id,
            managerId: ele.managerId?.id,
            reportingManagerComment: ele.reportingManagerComment,
            startDate: ele.startDate,
            taskStatus: ele.dwmStatus,
            empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName,
            taskStatusFlag: ele.dwmStatus == 'Completed' ? true : false,
            index: index
          }
          this.taskList.push(obj)
        });
        this.completedTaskStatusCount = this.taskList?.filter((item: { taskStatus: string; }) => item.taskStatus === 'Completed').length;
        this.paginationCountData();
      })
    }
  }
  addNewTask() {
    // if (!this.showAddNewSaveBtn) {
    if (this.selectedSubTab == 'Assign a Task') {
      this.taskList.push({
        actionable: '',
        byWhen: null,
        companyId: this.loggedInUserCompanyID,
        employeeComment: "",
        employeeId: null,
        extendDate1: null,
        extendDate2: null,
        extendDate3: null,
        id: null,
        managerId: this.loggedInUserId,
        percentageTaskCompletion: null,
        reportingManagerComment: "",
        startDate: null,
        taskStatus: 'NotStarted'
      });
    }
    if (this.selectedSubTab == 'Team DWM') {
      this.taskList.push({
        actionable: '',
        companyId: this.loggedInUserCompanyID,
        documentAttachment: null,
        documentName: null,
        employeeComment: "",
        employeeId: null,
        fixedTask: true,
        frequency: 'DAILY',
        id: null,
        managerId: this.loggedInUserId,
        percentageTaskCompletion: null,
        reportingManagerComment: "",
        startDate: null,
        taskStatus: 'InCompleted',
        taskStatusFlag: false,
        index: this.taskList?.length
      })
    }
    this.isEditIndexTask = this.taskList.length - 1;
    this.hideDeleteButton = true;
    this.showAddNewSaveBtn = true;
    // }
  }
  onClickDeleteRow(index: any) {
    this.taskList.splice(index, 1);
    this.hideDeleteButton = true;
    this.showAddNewSaveBtn = this.taskList?.some((ele: any) => ele.id == null);
  }
  onClickEditAssignedTasks(item: any, index: any) {
    this.isEditIndexTask = index;
    this.hideDeleteButton = false;
  }
  selectALLTaskRecords(event: any) {
    if (event.checked) {
      this.selectedTaskList = [];
      this.selectAllTaskCheckbox = true;
      for (let i = 0; i < this.taskList.length; i++) {
        this.taskList[i].checkboxCheck = true;
        this.selectedTaskList.push(this.taskList[i])
      }
    } else {
      for (let i = 0; i < this.taskList.length; i++) {
        this.taskList[i].checkboxCheck = false;
      }
      this.selectAllTaskCheckbox = false;
      this.selectedTaskList = [];
    }
  }
  selectSingleTaskRecords(event: any, data: any, i: number) {
    if (event.checked) {
      this.taskList[i].checkboxCheck = true;
      this.selectedTaskList.push(data);
    } else {
      this.selectAllTaskCheckbox = false;
      this.taskList[i].checkboxCheck = false;
      this.selectedTaskList.forEach((ele: any, ind: any) => {
        if (ele.checkboxCheck == false) {
          this.selectedTaskList.splice(ind, 1);
        }
      })
    }
  }
  getIndirectEmployeesList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployees.push(obj);
      });
      this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.getIndirectEmployeesForEmpWiseTaskStatus = this.getIndirectEmployees;
      this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus = this.getIndirectEmployees;
      this.getIndirectEmployeeTaskCompletionTaskStatus = this.getIndirectEmployees;
      this.getIndirectEmployeesForEmployeeWiseTasks = this.getIndirectEmployees;
      this.getIndirectEmployeesForEmployeeWiseTaskWithExtension = this.getIndirectEmployees;
      this.selectedEmployeeIdForReport = this.getIndirectEmployees;
      //this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId;
        this.selectedEmpIdForEmpWiseTask = this.loggedInUserId;
        this.selectedEmpIdForEmpWiseTaskWithExtention = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        if (this.getIndirectEmployees.length != 0) {
          this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployees[0].id,
            this.selectedEmpIdForEmpWiseTask = this.getIndirectEmployees[0].id,
            this.selectedEmpIdForEmpWiseTaskWithExtention = this.getIndirectEmployees[0].id;
        } else {
          this.selectedEmpIdForEmpWiseTaskStatus = null;
          this.selectedEmpIdForEmpWiseTask = null
          this.selectedEmpIdForEmpWiseTaskWithExtention = null;
        }

      }
    })
  }
  onClickSaveNewTask(index: any, operation: any) {
    var request = []
    var flag = true;
    if (operation == 'Add') {
      for (let i = 0; i < this.taskList?.length; i++) {
        if (this.taskList[i].id == null) {
          if (this.taskList[i].actionable == '') { flag = false, this.isTaskSubmitted = true; }
          if (this.taskList[i].byWhen == null) { flag = false, this.isTaskSubmitted = true; }
          if (this.taskList[i].employeeId == null) { flag = false, this.isTaskSubmitted = true; }
          if (this.taskList[i].startDate == null) { flag = false, this.isTaskSubmitted = true; }
          if (this.taskList[i].taskStatus == null) { flag = false, this.isTaskSubmitted = true; }
        }
      }
      if (flag == false) {
        // window.alert('Please fill Actionable, Assigned To, Start Date, End Date fields.')
        this.loader.dismissLoader();
        return
      }
      this.isTaskSubmitted = false;
      this.loader.simpleLoaderWithDuration();
      for (let i = 0; i < this.taskList.length; i++) {
        if (this.taskList[i].id == null) {
          request.push({
            actionable: this.taskList[i].actionable?.length > 255 ? this.taskList[i].actionable?.substring(0, 255) : this.taskList[i].actionable,
            byWhen: this.datePipe.transform(this.taskList[i].byWhen, 'yyyy-MM-dd'),
            companyId: this.loggedInUserCompanyID,
            employeeComment: this.taskList[i].employeeComment,
            employeeId: this.taskList[i].employeeId,
            extendDate1: this.datePipe.transform(this.taskList[i].extendDate1, 'yyyy-MM-dd'),
            extendDate2: this.datePipe.transform(this.taskList[i].extendDate2, 'yyyy-MM-dd'),
            extendDate3: this.datePipe.transform(this.taskList[i].extendDate3, 'yyyy-MM-dd'),
            id: this.taskList[i].id,
            managerId: this.taskList[i].managerId,
            percentageTaskCompletion: this.taskList[i].percentageTaskCompletion,
            reportingManagerComment: this.taskList[i].reportingManagerComment?.length > 255 ? this.taskList[i].reportingManagerComment?.substring(0, 255) : this.taskList[i].reportingManagerComment,
            startDate: this.datePipe.transform(this.taskList[i].startDate, 'yyyy-MM-dd'),
            taskStatus: this.taskList[i].taskStatus
          })
        }
      }
    }
    this.httpService.callPostService(this.config.addAsignedTaskList, request).subscribe((data: any) => {
      this.hideDeleteButton = false;
      this.showAddNewSaveBtn = false;
      this.loader.dismissLoader();
      if (operation == 'Add') {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: '#F3820E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.getCountOfTasks();
          this.getAllTasks();
          this.isEditIndexTask = null;
        });
      } else {
        this.getCountOfTasks();
        this.getAllTasks();
        this.isEditIndexTask = null;
      }
    })
  }
  onClickEditTask(index: any, operation: any) {
    var request = {}
    var flag = true;
    if (operation == 'Add') {
      var lastIndex = this.taskList.length - 1;
      if (this.taskList[lastIndex].actionable == '') { flag = false }
      if (this.taskList[lastIndex].byWhen == null) { flag = false }
      if (this.taskList[lastIndex].employeeId == null) { flag = false }
      if (this.taskList[lastIndex].startDate == null) { flag = false }
      if (this.taskList[lastIndex].taskStatus == null) { flag = false }
      if (flag == false) {
        window.alert('Please fill Actionable, Assigned To, Start Date, End Date fields.')
        this.loader.dismissLoader();
        return
      }
      this.loader.simpleLoaderWithDuration();
      // for (let i = 0; i < this.taskList.length; i++) {
      request = {
        actionable: this.taskList[lastIndex].actionable?.length > 255 ? this.taskList[lastIndex].actionable?.substring(0, 255) : this.taskList[lastIndex].actionable,
        byWhen: this.datePipe.transform(this.taskList[lastIndex].byWhen, 'yyyy-MM-dd'),
        companyId: this.loggedInUserCompanyID,
        employeeComment: this.taskList[lastIndex].employeeComment,
        employeeId: this.taskList[lastIndex].employeeId,
        extendDate1: this.datePipe.transform(this.taskList[lastIndex].extendDate1, 'yyyy-MM-dd'),
        extendDate2: this.datePipe.transform(this.taskList[lastIndex].extendDate2, 'yyyy-MM-dd'),
        extendDate3: this.datePipe.transform(this.taskList[lastIndex].extendDate3, 'yyyy-MM-dd'),
        id: this.taskList[lastIndex].id,
        managerId: this.taskList[lastIndex].managerId,
        percentageTaskCompletion: this.taskList[lastIndex].percentageTaskCompletion,
        reportingManagerComment: this.taskList[lastIndex].reportingManagerComment?.length > 255 ? this.taskList[lastIndex].reportingManagerComment?.substring(0, 255) : this.taskList[lastIndex].reportingManagerComment,
        startDate: this.datePipe.transform(this.taskList[lastIndex].startDate, 'yyyy-MM-dd'),
        taskStatus: this.taskList[lastIndex].taskStatus
      }
      // }
    } else {
      if (this.taskList[index].id == null) {
        return
      }
      request = {
        actionable: this.taskList[index].actionable?.length > 255 ? this.taskList[index].actionable?.substring(0, 255) : this.taskList[index].actionable,
        byWhen: this.datePipe.transform(this.taskList[index].byWhen, 'yyyy-MM-dd'),
        companyId: this.loggedInUserCompanyID,
        employeeComment: this.taskList[index].employeeComment?.length > 255 ? this.taskList[index].employeeComment?.substring(0, 255) : this.taskList[index].employeeComment,
        employeeId: this.taskList[index].employeeId,
        extendDate1: this.datePipe.transform(this.taskList[index].extendDate1, 'yyyy-MM-dd'),
        extendDate2: this.datePipe.transform(this.taskList[index].extendDate2, 'yyyy-MM-dd'),
        extendDate3: this.datePipe.transform(this.taskList[index].extendDate3, 'yyyy-MM-dd'),
        id: this.taskList[index].id,
        managerId: this.taskList[index].managerId,
        percentageTaskCompletion: this.taskList[index].percentageTaskCompletion,
        reportingManagerComment: this.taskList[index].reportingManagerComment?.length > 255 ? this.taskList[index].reportingManagerComment?.substring(0, 255) : this.taskList[index].reportingManagerComment,
        startDate: this.datePipe.transform(this.taskList[index].startDate, 'yyyy-MM-dd'),
        taskStatus: this.taskList[index].taskStatus
      }
    }
    this.httpService.callPostService(this.config.addAsignedTask, request).subscribe((data: any) => {
      this.hideDeleteButton = false;
      this.showAddNewSaveBtn = false;
      this.loader.dismissLoader();
      if (operation == 'Add') {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: '#F3820E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.getCountOfTasks();
          this.getAllTasks();
          this.isEditIndexTask = null;
        });
      } else {
        this.getCountOfTasks();
        this.getAllTasks();
        this.isEditIndexTask = null;
      }
    })
  }
  getAllTasks() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My Task') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee Task') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.loggedInUserId)
      userType = 2;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "search": this.searchString,
        "taskStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "userType": userType
      }
      this.httpService.callPostService(this.config.getAllTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask, request).subscribe((data: any) => {
        this.taskList = [];
        this.currentPageNumber = data?.data?.currentPageNumber + 1;
        this.totalTaskCount = data?.data?.total;
        this.totalTaskPages = data?.data?.totalPages;
        data.data?.setresponses?.forEach((ele: any) => {
          let obj = {
            assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
            actionable: ele.actionable,
            byWhen: this.datePipe.transform(ele.byWhen, 'yyyy-MM-dd'),
            companyId: ele.companyId,
            employeeComment: ele.employeeComment,
            employeeId: ele.employeeId?.id,
            extendDate1: ele.extendDate1,
            extendDate2: ele.extendDate2,
            extendDate3: ele.extendDate3,
            id: ele.id,
            managerId: ele.managerId?.id,
            percentageTaskCompletion: ele.percentageTaskCompletion,
            reportingManagerComment: ele.reportingManagerComment,
            startDate: this.datePipe.transform(ele.startDate, 'yyyy-MM-dd'),
            taskStatus: ele.taskStatus,
            empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName
          }
          this.taskList.push(obj)
        });
        this.paginationCountData();
      })
    }
  }
  validatePercentageTaskCompletion(event: any, index: number) {
    if (this.taskList[index].percentageTaskCompletion < 0) {
      this.taskList[index].percentageTaskCompletion = 0;
      this.toastr.error('Range of % of task completion is 0 to 100', '', {
        timeOut: 3000,
      });
    } else if (this.taskList[index].percentageTaskCompletion > 100) {
      this.taskList[index].percentageTaskCompletion = 0;
      this.toastr.error('Range of % of task completion is 0 to 100', '', {
        timeOut: 3000,
      });
    }
  }
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getIndirectEmployees = [];
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          }
          this.getIndirectEmployees.push(obj);
        });
        this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name))
        this.getIndirectEmployeesForEmpWiseTaskStatus = this.getIndirectEmployees;
        this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus = this.getIndirectEmployees;
        this.getIndirectEmployeeTaskCompletionTaskStatus = this.getIndirectEmployees;
        this.getIndirectEmployeesForEmployeeWiseTasks = this.getIndirectEmployees;
        this.getIndirectEmployeesForEmployeeWiseTaskWithExtension = this.getIndirectEmployees;
        this.selectedMultiEmployeeId = this.getIndirectEmployees;
        this.selectedEmployeeIdForReport = this.getIndirectEmployees;

        if (this.selectedTypeTabName == 'Review Meeting') {
          if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
            || this.loggedInUserRole == 'PHI Admin') {
            {
              if (this.selectedSubTab == 'Reports') {
                this.taskManagmentReport();
              } else {
                this.getAllTasks();
              }
              this.getCountOfTasks();
            }
          }
        } else {
          if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
            || this.loggedInUserRole == 'PHI Admin') {
            {
              if (this.selectedSubTab == 'Reports') {
                this.taskManagmentReport();
              } else {
                this.getAllDWMTasks();
              }
              this.getCountOfMyDailyWork();
              this.getCountOfDWMWorkTasks();
            }
          }
        }
        if (this.getIndirectEmployees.length != 0) {
          this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id;
          this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployees[0].id;
          this.selectedEmpIdForEmpWiseTask = this.getIndirectEmployees[0].id;
          this.selectedEmpIdForEmpWiseTaskWithExtention = this.getIndirectEmployees[0].id;
          this.selectedEmpIdForDWMEmpWiseTaskStatus = this.getIndirectEmployees[0].id;
          this.selectedEmpIdForDWMEmpCompletionStatus = this.getIndirectEmployees[0].id;
        } else {
          this.selectedEmpIdForDashboard = null;
          this.selectedEmpIdForEmpWiseTaskStatus = null
          this.selectedEmpIdForEmpWiseTask = null
          this.selectedEmpIdForEmpWiseTaskWithExtention = null
          this.selectedEmpIdForDWMEmpWiseTaskStatus = null
          this.selectedEmpIdForDWMEmpCompletionStatus = null
        }
      }, (error: any) => {
      }, () => { });
  }
  onClickExtendDueDate(item: any) {
    var minDate = null;
    var extensionNumber = 1;
    if (item.byWhen != null) {
      minDate = item.byWhen
      extensionNumber = 1;
    }
    if (item.extendDate1 != null) {
      minDate = item.extendDate1
      extensionNumber = 2;
    }
    if (item.extendDate2 != null) {
      minDate = item.extendDate2
      extensionNumber = 3;
    }
    if (item.extendDate3 != null) {
      minDate = item.extendDate3
      extensionNumber = 3;
    }
    const successdialogRef = this.dialog.open(ExtendDueDatePopupComponent, {
      disableClose: true,
      height: '25%',
      width: '22%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        btn1: 'Cancel',
        btn2: 'Set Date',
        btn2BgColor: this.buttonColorName,
        id: item.id,
        minDate: minDate,
        showExtendedDueDate: true,
        extensionNumber: extensionNumber
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getCountOfTasks();
        this.getAllTasks();
      }
    });
  }
  fileName: any = null;
  fileType: any = null;
  uploadedFileUrl: any = null;
  uploadImage(event: any, index: any) {
    const fileSizeInKB = event.target.files[0].size / 1024;
    const fileSizeInMB = fileSizeInKB / 1024;

    if (fileSizeInMB > 10) {
      window.alert("File size is greater than 10MB");
      return;
    }
    var flag = true;
    if (flag) {
      const fileName = event.target.files[0].name;
      const fileType = event.target.files[0].type;
      const formData = new FormData();
      formData.append('file', event.target.files[0]);
      const url = this.config.uploadFileLocally + `?fileName=${fileName}&fileType=${fileType}`
      this.loader.simpleLoaderWithDuration();
      this.httpService.submitFormService(url, formData).subscribe((res: any) => {
        this.loader.dismissLoader();
        this.fileName = event.target.files[0].name;
        this.fileType = event.target.files[0].type;
        this.uploadedFileUrl = res.data;
        this.taskList[index].documentAttachment = res.data;
        this.taskList[index].documentName = this.fileName;
        this.onClickEditDWM(index, 'Edit');
      }, (error: any) => {
        this.loader.dismissLoader();
      })
    }
  }
  updateDWMValue(event: any, index: number, field: any) { }
  isTaskSubmitted: boolean = false;
  onClickSaveNewDWM(index: any, operation: any) {
    var request = []
    var flag = true;
    if (this.sameActionableAlreayExists) {
      this.toastr.error('Same Actionable already exists.', '', {
        timeOut: 3000,
      });
      return;
    } else {
      if (operation == 'Add') {
        for (let i = 0; i < this.taskList.length; i++) {
          if (this.taskList[i].id == null) {
            if (this.taskList[i].actionable == '') { flag = false, this.isTaskSubmitted = true }
            if (this.taskList[i].taskStatus == null) { flag = false, this.isTaskSubmitted = true }
          }
        }
        if (flag == false) {
          this.loader.dismissLoader();
          return
        }
        this.isTaskSubmitted = false;
        this.loader.simpleLoaderWithDuration();
        for (let i = 0; i < this.taskList.length; i++) {
          if (this.taskList[i].id == null) {
            request.push({
              actionable: this.taskList[i].actionable?.length > 255 ? this.taskList[i].actionable?.substring(0, 255) : this.taskList[i].actionable,
              companyId: this.taskList[i].companyId,
              documentAttachment: this.taskList[i].documentAttachment,
              documentName: this.taskList[i].documentName,
              employeeComment: this.taskList[i].employeeComment,
              employeeId: this.selectedEmployeeId,
              fixedTask: this.taskList[i].fixedTask,
              frequency: this.taskList[i].frequency,
              id: this.taskList[i].id,
              managerId: this.taskList[i].managerId,
              percentageTaskCompletion: this.taskList[i].percentageTaskCompletion,
              reportingManagerComment: this.taskList[i].reportingManagerComment?.length > 255 ? this.taskList[i].reportingManagerComment?.substring(0, 255) : this.taskList[i].reportingManagerComment,
              startDate: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
              dwmStatus: this.taskList[i].taskStatus,
              reviewByEmployee: this.taskIsReviewByEmployee
            })
          }
        }
        this.httpService.callPostService(this.config.addDWMTaskList, request).subscribe((data: any) => {
          this.showAddNewSaveBtn = false;
          this.loader.dismissLoader();
          if (operation == 'Add') {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: '#F3820E',
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getCountOfMyDailyWork();
              this.getCountOfDWMWorkTasks();
              this.getAllDWMTasks();
              this.isEditIndexTask = null;
            });
          } else {
            this.getCountOfMyDailyWork();
            this.getCountOfDWMWorkTasks();
            this.getAllDWMTasks();
            this.isEditIndexTask = null;
          }
        })
      }
    }
  }
  onClickEditDWM(index: any, operation: any) {
    var request = {}
    var flag = true;
    if (this.selectedSubTab == 'My DWM') {
      this.taskIsReviewByEmployee = true;
    }
    if (operation == 'Add') {
      // for (let i = 0; i < this.taskList.length; i++) {
      var lastIndex = this.taskList.length - 1;
      if (this.taskList[lastIndex].actionable == '') { flag = false }
      if (this.taskList[lastIndex].taskStatus == null) { flag = false }
      if (flag == false) {
        window.alert('Please fill Actionable field.')
        this.loader.dismissLoader();
        return
      }
      this.loader.simpleLoaderWithDuration();
      request = {
        actionable: this.taskList[lastIndex].actionable?.length > 255 ? this.taskList[lastIndex].actionable?.substring(0, 255) : this.taskList[lastIndex].actionable,
        companyId: this.taskList[lastIndex].companyId,
        documentAttachment: this.taskList[lastIndex].documentAttachment,
        documentName: this.taskList[lastIndex].documentName,
        employeeComment: this.taskList[lastIndex].employeeComment,
        employeeId: this.selectedEmployeeId,
        fixedTask: this.taskList[lastIndex].fixedTask,
        frequency: this.taskList[lastIndex].frequency,
        id: this.taskList[lastIndex].id,
        managerId: this.taskList[lastIndex].managerId,
        percentageTaskCompletion: this.taskList[lastIndex].percentageTaskCompletion,
        reportingManagerComment: this.taskList[lastIndex].reportingManagerComment?.length > 255 ? this.taskList[lastIndex].reportingManagerComment?.substring(0, 255) : this.taskList[lastIndex].reportingManagerComment,
        startDate: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
        dwmStatus: this.taskList[lastIndex].taskStatus,
        reviewByEmployee: this.taskIsReviewByEmployee,
      }
      // }
    } else {
      if (this.taskList[index].id == null) {
        return
      }
      request = {
        actionable: this.taskList[index].actionable?.length > 255 ? this.taskList[index].actionable?.substring(0, 255) : this.taskList[index].actionable,
        companyId: this.taskList[index].companyId,
        documentAttachment: this.taskList[index].documentAttachment,
        documentName: this.taskList[index].documentName,
        employeeComment: this.taskList[index].employeeComment?.length > 255 ? this.taskList[index].employeeComment?.substring(0, 255) : this.taskList[index].employeeComment,
        employeeId: this.taskList[index].employeeId,
        fixedTask: this.taskList[index].fixedTask,
        frequency: this.taskList[index].frequency,
        id: this.taskList[index].id,
        managerId: this.taskList[index].managerId,
        percentageTaskCompletion: this.taskList[index].percentageTaskCompletion,
        reportingManagerComment: this.taskList[index].reportingManagerComment?.length > 255 ? this.taskList[index].reportingManagerComment?.substring(0, 255) : this.taskList[index].reportingManagerComment,
        startDate: this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
        dwmStatus: this.taskList[index].taskStatus,
        reviewByEmployee: this.taskIsReviewByEmployee,
      }
    }
    this.httpService.callPostService(this.config.updateDailyWorkManagement, request).subscribe((data: any) => {
      this.showAddNewSaveBtn = false;
      this.loader.dismissLoader();
      if (operation == 'Add') {
        const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
          maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
          data: {
            msg: data.data,
            btn2: 'OK',
            btn2BgColor: '#F3820E',
            showSuccessIcon: true,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        successdialogRef.afterClosed().subscribe(result => {
          this.getCountOfMyDailyWork();
          this.getCountOfDWMWorkTasks();
          this.getAllDWMTasks();
          this.isEditIndexTask = null;
        });
      } else {
        this.getCountOfMyDailyWork();
        this.getCountOfDWMWorkTasks();
        this.getAllDWMTasks();
        this.isEditIndexTask = null;
      }
    })
  }

  isTaskAvailableForEmployee: boolean = false;

  getAllDWMTasks() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My DWM') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee DWM') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      let newId = this.selectedEmployeeId || this.selectedEmpIdForDashboard
      ids.push(newId)
      userType = 2;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": ids,
      "search": this.searchString,
      "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "userType": userType
    }
    this.httpService.callPostService(this.config.getDWMTasks + '?page=' + this.page + '&size=' + this.selectedSizeOfTask, request).subscribe((data: any) => {
      this.taskList = [];
      this.currentPageNumber = data?.data?.currentPageNumber + 1;
      this.totalTaskCount = data?.data?.total;
      this.totalTaskPages = data?.data?.totalPages;
      this.taskIsReviewByEmployee = data.data?.dailyWorkManagement?.some((ele: any) => ele.isReviewed);
      data.data?.dailyWorkManagement?.forEach((ele: any, index: any) => {
        let obj = {
          assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
          actionable: ele.actionable,
          companyId: ele.companyId,
          documentAttachment: ele.documentAttachment,
          documentName: ele.documentName,
          employeeComment: ele.employeeComment,
          employeeId: ele.employeeId?.id,
          fixedTask: ele.fixedTask,
          frequency: ele.frequency,
          id: ele.id,
          managerId: ele.managerId?.id,
          reportingManagerComment: ele.reportingManagerComment,
          startDate: ele.startDate,
          taskStatus: ele.dwmStatus,
          empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName,
          taskStatusFlag: ele.dwmStatus == 'Completed' ? true : false,
          index: index
        }
        this.taskList.push(obj)
      });
      this.isTaskAvailableForEmployee = this.taskList.length > 0;
      this.completedTaskStatusCount = this.taskList?.filter((item: { taskStatus: string; }) => item.taskStatus === 'Completed').length;
      this.paginationCountData();
    })
  }
  newEmployeewise: any = [];
  onChangeSelectedEmployee() {
    if (this.selectedSubTab == 'Employee Task') {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedSubTab == 'Team DWM' || this.selectedSubTab == 'Employee DWM') {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
      this.skipDayManagerComment();
    }
    if (this.selectedTypeTabName == 'Review Meeting') {
      if (this.selectedSubTab == 'Dashboard') {
        this.selectedEmpIdForEmpWiseTask = this.selectedEmpIdForDashboard;
        this.selectedEmpIdForEmpWiseTaskStatus = this.selectedEmpIdForDashboard;
        this.selectedEmpIdForEmpWiseTaskWithExtention = this.selectedEmpIdForDashboard;

        this.taskAssignedByMeFunction();
        this.taskAssignedToMeFunction();
        this.getEmployeeWiseTaskStatus()
        this.getEmployeeWiseTask();
        this.getEmployeeWiseTasksWithExtensions();
        this.onDateChangeMyComingWeekTask();
        this.onDateChangeAllocatedTask();
      }
    } else {
      if (this.selectedSubTab == 'Dashboard') {
        this.selectedEmpIdForDWMEmpWiseTaskStatus = this.selectedEmpIdForDashboard;
        // this.selectedEmpIdForDWMEmpCompletionStatus = this.selectedEmpIdForDashboard;
        this.selectedIdForDWMCount = this.selectedEmpIdForDashboard;
        this.dwmDashboardCounts();
        this.getDWMTaskActionableList();
        setTimeout(() => {
          this.getDWMEmployeeWiseTaskStatus();
          this.getcountOfEmployeeWiseTaskCompletionStatus();


        }, 1000)
      }
    }
  }



  //  =============================================   Frequency  ==================================================

  onChangeSelectedFrequency(index: any, operation: any) {



    // Same condition as toggle
    if (operation == 'Edit' && !this.showAddNewSaveBtn) {
      this.onClickEditDWM(index, operation);
    }
  }

  confirmFrequencyChange(event: any, item: any, index: any) {
    // If Save button is visible → don’t show popup
    if (this.showAddNewSaveBtn) {
      return;
    }
    const newValue = event.value;

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to change this frequency?',
        btn1: 'No',
        btn2: 'Yes',
        btn1BgColor: this.buttonColorName,
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if (result === true) {
        // User clicked YES → apply your original logic
        this.onChangeSelectedFrequency(index, 'Edit');
        setTimeout(() => {
          this.toastr.success('Frequency updated successfully.', 'Success');
        }, 200);
      } else {
        // User clicked NO → revert the selection
        item.frequency = item.oldFrequency;
      }
    });
  }

  onChangeFrequencyWithConfirm(index: any, item: any) {

    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 576 ? '100%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Are you sure you want to change this frequency?',
        btn1: 'No',
        btn2: 'Yes',
        btn1BgColor: this.buttonColorName,
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // User clicked YES → call your original logic
        this.onChangeSelectedFrequency(index, 'Edit');
      } else {
        // User clicked NO → revert back to old value
        item.frequency = item.oldFrequency;
      }
    });
  }


  onDWMDateChange() {

    this.getCountOfMyDailyWork();
    this.getCountOfDWMWorkTasks();
    this.getAllDWMTasks();
    this.skipDayManagerComment();
  }



  onChangeReportOf(event: any) {
    this.taskList = [];
    if (this.selectedReportOf == 'Team DWM') {
      this.initilaizeDWMColumn();
      this.selectedEmployeeIdForReport = [];
      this.taskList = [];
      this.getAssignedDWMEmpOfManger();
    }
    if (this.selectedReportOf == 'My DWM') {
      this.initilaizeDWMColumn();
      this.taskManagmentReport();
    }
    if (this.selectedReportOf == 'Assign a Task') {
      this.initilaizeTaskColumn();
      this.taskList = [];
      this.selectedEmployeeIdForReport = [];
      this.getAssignedTasksEmpOfManger();
    }
    if (this.selectedReportOf == 'My Task') {
      this.initilaizeTaskColumn();
      this.taskManagmentReport();
    }
  }
  selectAllEmpForReport(event: any) {
    this.selectedEmployeeIdForReport = event;
    this.taskManagmentReport();
  }
  onDeSelectAllEmpForReport() {
    this.selectedEmployeeIdForReport = [];
    this.taskManagmentReport();
  }
  onSelectSingleSelectFilterReport() {
    this.taskManagmentReport();
  }
  onSelectSingleSelectFilterEmpTasks() {
    if (this.selectedSubTab == "Employee Task") {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedSubTab == "Employee DWM") {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
    }
  }
  selectAllEmpForTask(event: any) {
    this.selectedMultiEmployeeId = event;
    if (this.selectedSubTab == "Employee Task") {
      this.getCountOfTasks();
      this.getAllTasks();
    }
    if (this.selectedSubTab == "Employee DWM") {
      this.getCountOfMyDailyWork();
      this.getCountOfDWMWorkTasks();
      this.getAllDWMTasks();
    }
  }
  onDeSelectAllEmpTask() {
    this.selectedMultiEmployeeId = [];
    this.taskList = [];
  }
  onClickClearFilterReport() {
    this.selectedEmployeeIdForReport = [];
    if (this.selectedTypeTabName == 'Review Meeting') {
      this.selectedReportOf = 'My Task';
      this.taskList = [];
    } else {
      this.selectedReportOf = 'My DWM'
      this.dWMReportTaskList = [];
    }
    this.taskFromDate = null;
    this.taskToDate = null;
    this.taskList = [];
    this.searchString = null;
  }
  getAssignedDWMEmpOfManger() {
    const request = {
      "employeeId": this.loggedInUserId,
      "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
    }
    this.httpService.callPostService(this.config.getAssignedDWMEmpOfManger, request)
      .subscribe((data: any) => {
        this.getIndirectEmployees = [];
        data?.data?.finalResponse.forEach((ele: any) => {
          let obj = {
            id: ele.employeeId,
            name: ele.firstName + ' ' + ele.lastName,
          }
          this.getIndirectEmployees.push(obj);
        });
        this.newEmployeewise = this.getIndirectEmployees;
        this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name))

      }, (error: any) => {
      }, () => { });
  }
  getAssignedTasksEmpOfManger() {
    const request = {
      "employeeId": this.loggedInUserId
    }
    this.httpService.callPostService(this.config.getAssignedTasksEmpOfManger, request)
      .subscribe((data: any) => {
        this.getIndirectEmployees = [];
        data?.data?.finalResponse.forEach((ele: any) => {
          let obj = {
            id: ele.employeeId,
            name: ele.firstName + ' ' + ele.lastName,
          }
          this.getIndirectEmployees.push(obj);
        });
        this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name))

      }, (error: any) => {
      }, () => { });
  }


  // 

  todayDate: any = new Date().toISOString().split('T')[0];

  // Task Management Report 

  taskManagmentReport() {
    if (this.selectedTypeTabName == 'Review Meeting') {
      var employeeIds = [];
      if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        || this.loggedInUserRole == 'PHI Admin') {
        employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
      } else {
        if (this.selectedReportOf == 'My Task') {
          employeeIds = [this.loggedInUserId]
        } else {
          employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
        }
      }
      if (this.taskFromDate != null && this.taskToDate != null) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "employeeId": employeeIds,
          "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
          "search": this.searchString,
          "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        };
        this.httpService.callPostService(this.config.taskManagmentReviewReport + '?page=' + this.page + '&size=' +
          this.selectedSizeOfTask, request).subscribe((data: any) => {
            this.taskList = [];
            this.totalTaskPages = data?.data?.totalPages;
            this.totalTaskCount = data?.data?.total;
            this.currentPageNumber = data?.data?.currentPageNumber + 1;
            data.data?.response?.forEach((ele: any) => {
              let obj = {
                assignedBy: ele.managerId?.firstName + ' ' + ele.managerId?.lastName,
                actionable: ele.actionable,
                byWhen: this.datePipe.transform(ele.byWhen, 'yyyy-MM-dd'),
                companyId: ele.companyId,
                employeeComment: ele.employeeComment,
                employeeId: ele.employeeId,
                extendDate1: ele.extendDate1,
                extendDate2: ele.extendDate2,
                extendDate3: ele.extendDate3,
                id: ele.id,
                managerId: ele.managerId,
                percentageTaskCompletion: ele.percentageTaskCompletion,
                reportingManagerComment: ele.reportingManagerComment,
                startDate: this.datePipe.transform(ele.startDate, 'yyyy-MM-dd'),
                taskStatus: ele.taskStatus,
                empName: ele.employeeId?.firstName + ' ' + ele.employeeId?.lastName
              }
              this.taskList.push(obj)
            });
            this.paginationCountData();
          })
      }
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      var employeeIds = [];
      if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        || this.loggedInUserRole == 'PHI Admin') {
        employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
      } else {
        if (this.selectedReportOf == 'My DWM') {
          employeeIds = [this.loggedInUserId]
        } else {
          employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
        }
      }
      if (this.taskFromDate != null && this.taskToDate != null) {
        const request = {
          "companyId": this.loggedInUserCompanyID,
          "employeeId": employeeIds,
          "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
          "search": this.searchString,
          "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        };
        this.httpService.callPostService(this.config.teamDwmDailyReport + '?page=' + this.page + '&size=' +
          this.selectedSizeOfTask, request).subscribe((data: any) => {
            this.dWMReportTaskList = [];
            data.data?.forEach((ele: any) => {
              let completedStatusListDateWise: any = [];
              let tableList: any = [];
              let dWMReportDisplayDate: any = [];
              ele?.setListResponse.forEach((ele1: any) => {
                let dateRangeList: any = [];
                let completedCount = 0
                ele1?.assignedResponse.forEach((ele2: any) => {
                  let obj1 = {
                    documentAttachment: ele2.documentAttachment,
                    dwmStatus: ele2.dwmStatus,
                    month: ele2.month,
                    skipDate: ele2.skipDate,
                    startDate: ele2.startDate,
                    displayDate: this.datePipe.transform(ele2.startDate, 'd MMMM')
                  }
                  dateRangeList.push(obj1);
                  if (ele2.dwmStatus == 'Completed') {
                    completedCount++;
                  }
                });
                let obj2 = {
                  actionable: ele1.actionable,
                  frequency: ele1.frequency,
                  assignedResponse: dateRangeList,
                  completedCount: completedCount,
                }
                tableList.push(obj2);
              });
              for (let i = 0; i < ele?.setListResponse[0].assignedResponse.length; i++) {
                let obj = {
                  date: this.datePipe.transform(ele?.setListResponse[0].assignedResponse[i].startDate, 'd MMM'),
                  mapDate: this.datePipe.transform(ele?.setListResponse[0].assignedResponse[i].startDate, 'yyyy-MM-dd'),
                  skipDate: null
                }
                dWMReportDisplayDate.push(obj);
              }
              for (let i = 0; i < dWMReportDisplayDate.length; i++) {
                for (let j = 0; j < ele?.skipDates.length; j++) {
                  if (dWMReportDisplayDate[i].mapDate == ele?.skipDates[j]) {
                    dWMReportDisplayDate[i].skipDate = ele?.skipDates[j];
                  }
                }
              }
              let statusCountArray: any[] = []
              for (let k = 0; k < ele?.setListResponse[0].assignedResponse.length; k++) {
                let completeCount = 0;
                let date: any;
                for (let l = 0; l < ele?.setListResponse.length; l++) {
                  if (ele?.setListResponse[l].assignedResponse[k].dwmStatus == 'Completed' && ele?.setListResponse[l].assignedResponse[k].skipDate == null) {
                    completeCount++;
                  }
                  date = ele?.setListResponse[l].assignedResponse[k].startDate
                }
                let obj = {
                  completeCount: completeCount,
                  date: date
                }
                statusCountArray.push(obj)
              }
              let obj = {
                empName: ele?.firstName + ' ' + ele?.lastName,
                reportingManagerName: ele.setManagerFirstName + ' ' + ele.setManagerLastName,
                department: ele.department,
                designation: ele.designation,
                skipDateCount: ele.skipDateCount,
                month: ele.month,
                setListResponse: tableList,
                dWMReportDisplayDate: dWMReportDisplayDate,
                statusCountArray: statusCountArray
              }
              this.dWMReportTaskList.push(obj);
            });
            this.paginationCountData();
          })
      }
    }
  }
  onClickDeleteRecord() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '30%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete this record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        for (let i = 0; i < this.taskList.length; i++) {
          if (this.taskList[i].checkboxCheck == true && this.taskList[i].id == null) {
            this.taskList.splice(i, 1);
          }
        }
        if (this.selectedTaskList?.some((ele: any) => ele.id == null)) {
          this.selectedTaskList = [];
          this.selectAllTaskCheckbox = false;
        }
        if (this.selectedTaskList?.some((ele: any) => ele.id != null)) {
          const request = {
            "id": this.selectedTaskList?.map((ele: { id: any; }) => ele.id),
            "isDeleted": true
          }
          this.httpService.callPostService(this.config.deleteAssignedTask, request).subscribe((res: any) => {
            this.selectedTaskList = [];
            this.selectAllTaskCheckbox = false;

            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '30%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: res?.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getCountOfTasks();
              this.getAllTasks();

            });
          }, (error: any) => {
          })
        }
      }
    });
  }
  onClickDailyDeleteRecord() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '30%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        msg: 'Do you really want to delete this record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        for (let i = 0; i < this.taskList.length; i++) {
          if (this.taskList[i].checkboxCheck == true && this.taskList[i].id == null) {
            this.taskList.splice(i, 1);
          }
        }
        if (this.selectedTaskList?.some((ele: any) => ele.id == null)) {
          this.selectedTaskList = [];
          this.selectAllTaskCheckbox = false;
        }
        if (this.selectedTaskList?.some((ele: any) => ele.id != null)) {
          const request = {
            "id": this.selectedTaskList?.map((ele: { id: any; }) => ele.id),
            "isDeleted": true
          }
          this.httpService.callPostService(this.config.deleteDailyWorkTask, request).subscribe((res: any) => {
            this.selectedTaskList = [];
            this.selectAllTaskCheckbox = false;
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '30%',
              width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
              maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
              data: {
                msg: res?.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getCountOfMyDailyWork();
              this.getCountOfDWMWorkTasks();
              this.getAllDWMTasks();
            });
          }, (error: any) => {
          })
        }
      }
    });
  }
  get isThisFixedTaskToggleDisabled(): boolean {
    return this.selectedSubTab != 'Team DWM';
  }
  isAnyDateGreaterThanToday(item: any): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time part to ensure only date comparison
    var dates = [];
    const byWhen = new Date(item.byWhen)
    const extendDate1 = new Date(item.extendDate1)
    const extendDate2 = new Date(item.extendDate2)
    const extendDate3 = new Date(item.extendDate3)
    byWhen.setHours(0, 0, 0, 0); extendDate1.setHours(0, 0, 0, 0); extendDate2.setHours(0, 0, 0, 0); extendDate3.setHours(0, 0, 0, 0);
    dates.push(byWhen)
    dates.push(extendDate1)
    dates.push(extendDate2)
    dates.push(extendDate3)
    return dates.some((date: Date) =>
      date.getTime() >= today.getTime());
  }
  isDWMisEdiable(item: any): boolean {
    if (this.selectedSubTab == 'Team DWM') {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDateToCheck = new Date(this.dailyTeamTaskFromDate)
      selectedDateToCheck.setHours(0, 0, 0, 0);
      if (selectedDateToCheck > today) {
        const currentMonth = selectedDateToCheck.getMonth(); // Get current month (0-based index)
        const currentYear = selectedDateToCheck.getFullYear(); // Get current year
        const firstDayOfNextMonth = new Date(currentYear, currentMonth + 1, 1);
        const lastDayOfCurrentMonthTimestamp = firstDayOfNextMonth.getTime() - 1;
        const lastDayOfCurrentMonth = new Date(lastDayOfCurrentMonthTimestamp)
        lastDayOfCurrentMonth.setHours(0, 0, 0, 0);
        return selectedDateToCheck.getTime() <= lastDayOfCurrentMonth.getTime()
      } else {
        const currentMonth = today.getMonth(); // Get current month (0-based index)
        const currentYear = today.getFullYear(); // Get current year
        const firstDayOfNextMonth = new Date(currentYear, currentMonth + 1, 1);
        const lastDayOfCurrentMonthTimestamp = firstDayOfNextMonth.getTime() - 1;
        const lastDayOfCurrentMonth = new Date(lastDayOfCurrentMonthTimestamp)
        lastDayOfCurrentMonth.setHours(0, 0, 0, 0);
        return selectedDateToCheck.getTime() <= lastDayOfCurrentMonth.getTime()
      }
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const twoDaysBack = new Date(today);
      twoDaysBack.setDate(today.getDate());
      const selectedDateToCheck = new Date(this.dailyTeamTaskFromDate)
      selectedDateToCheck.setHours(0, 0, 0, 0);
      return selectedDateToCheck.getTime() == twoDaysBack.getTime()
    }
  }
  get isCheckSelectedDateIsTodaysDate(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time part to ensure only date comparison
    const selectedDateToCheck = new Date(this.dailyTeamTaskFromDate)
    selectedDateToCheck.setHours(0, 0, 0, 0);
    // let calculatedSelectedDateNumber = selectedDateToCheck.getTime();
    // let todayDateNumber = today.getTime();
    return selectedDateToCheck >= today;
  }
  previousPageTask() {
    if (this.currentPageNumber < 2) {
      return;
    } else {
      this.currentPageNumber--;
      this.page--;
      if (this.selectedTypeTabName == 'Review Meeting') {
        if (this.selectedSubTab == 'Reports') {
          this.taskManagmentReport();
        } else {
          this.getCountOfTasks();
          this.getAllTasks();
        }
      }
      if (this.selectedTypeTabName == 'Daily Work Management') {
        if (this.selectedSubTab == 'Reports') {
          this.taskManagmentReport();
        } else {
          this.getCountOfMyDailyWork();
          this.getCountOfDWMWorkTasks();
          this.getAllDWMTasks();
        }
      }
    }
  }
  nextPageTask() {
    if (this.currentPageNumber >= this.totalTaskPages) {
      return;
    }
    if (this.currentPageNumber == 1) {
      this.page = 1;
    } else {
      this.page++;
    }
    this.currentPageNumber++;
    if (this.selectedTypeTabName == 'Review Meeting') {
      if (this.selectedSubTab == 'Reports') {
        this.taskManagmentReport();
      } else {
        this.getCountOfTasks();
        this.getAllTasks();
      }
    }
    if (this.selectedTypeTabName == 'Daily Work Management') {
      if (this.selectedSubTab == 'Reports') {
        this.taskManagmentReport();
      } else {
        this.getCountOfMyDailyWork();
        this.getCountOfDWMWorkTasks();
        this.getAllDWMTasks();
      }
    }
  }
  paginationCountData() {
    if (this.previousPageTotalCount != this.totalTaskCount) {
      this.showingCount = 1;
      this.showingOfCount = 0;
    }
    if ((this.currentPageNumber - 1) == 0) {
      this.showingCount = 1;
      this.showingOfCount = 0;
    }
    if (this.totalTaskCount >= this.taskList.length) {
      if (this.selectedSizeOfTask == this.taskList.length) {
        this.showingOfCount = ((this.currentPageNumber - 1) + 1) * this.selectedSizeOfTask;
      } else {
        this.showingOfCount = this.showingOfCount + this.taskList.length
      }
      this.previousPageTotalCount = this.totalTaskCount;
    }
    if ((this.currentPageNumber - 1) == 0) {
      this.showingCount = 1;
    } else {
      this.showingCount = (this.selectedSizeOfTask * (this.currentPageNumber - 1)) + 1
    }
  }
  getCountOfTasks() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My Task') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.loggedInUserId)
      userType = 2;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "search": this.searchString,
        "taskStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "userType": null
      }
      this.httpService.callPostService(this.config.getCountOfTasks, request).subscribe((data: any) => {
        this.assignedTaskCount = data?.assignedTaskCount;
        this.myTaskCount = data?.myTaskCount;
      })
    }
  }

  getCountOfDWMWorkTasks() {

    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My DWM') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee DWM') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.selectedEmployeeId)
      userType = 2;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": ids,
      "search": this.searchString,
      "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "userType": userType
    }
    this.httpService.callPostService(this.config.getCountOfDWMWork, request).subscribe((data: any) => {
      if (this.selectedSubTab == 'Team DWM') {
        this.teamDWMCount = data?.myworkCount;
      } else {
        this.teamDWMCount = 0;
      }
      // this.myDWMCount = data?.assignedMyWorkCount;
    })
  }
  // getTeamOfManager() {
  //   const request = {
  //     "companyId": this.loggedInUserCompanyID,
  //     "date": null,
  //     "from": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
  //     "fromYear": null,
  //     "to": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
  //     "toYear": null,
  //     "userId": this.loggedInUserId,
  //     "userType": null,
  //     "yearRange": null
  //   }
  //   this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request).subscribe((data: any) => {

  //     this.getIndirectEmployees = [];
  //     data?.data?.forEach((ele: any) => {
  //       let obj = {
  //         name: ele?.firstName + ' ' + ele?.lastName,
  //         id: ele?.id
  //       }
  //       this.getIndirectEmployees.push(obj);
  //     });
  //     this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name))

  //     if (this.selectedSubTab == 'Dashboard') {
  //       if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
  //         this.selectedEmpIdForDashboard = this.loggedInUserId;
  //         this.selectedEmployeeId = this.loggedInUserId;
  //         this.selectedEmpIdForDWMEmpWiseTaskStatus = this.loggedInUserId;
  //         this.selectedEmpIdForDWMEmpCompletionStatus = this.loggedInUserId;
  //         this.selectedIdForDWMCount = this.loggedInUserId;
  //         this.getCountOfMyDailyWork();
  //       } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
  //         if (this.getIndirectEmployees.length != 0) {
  //           this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id;
  //           this.selectedEmployeeId = this.getIndirectEmployees[0].id;
  //           this.selectedEmpIdForDWMEmpWiseTaskStatus = this.getIndirectEmployees[0].id;
  //           this.selectedEmpIdForDWMEmpCompletionStatus = this.getIndirectEmployees[0].id;
  //           this.selectedIdForDWMCount = this.getIndirectEmployees[0].id;
  //         }
  //         this.getCountOfMyDailyWork();
  //       }
  //     } else {
  //       if (this.getIndirectEmployees.length != 0) {
  //         this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id;
  //         this.selectedEmployeeId = this.getIndirectEmployees[0].id;
  //         this.selectedEmpIdForDWMEmpWiseTaskStatus = this.getIndirectEmployees[0].id;
  //         this.selectedEmpIdForDWMEmpCompletionStatus = this.getIndirectEmployees[0].id;
  //         this.selectedIdForDWMCount = this.getIndirectEmployees[0].id;
  //       }
  //       this.getCountOfMyDailyWork();
  //     }
  //   })

  // }


  getTeamOfManager() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }

    this.httpService.callPostService(this.config.getTeamOfManagerForDWm, request).subscribe((data: any) => {
      this.getIndirectEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          name: ele?.firstName + ' ' + ele?.lastName,
          id: ele?.id
        }
        this.getIndirectEmployees.push(obj);
      });
      this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name));

      //  update selectedEmployeeId if needed
      const isSelectedStillInList = this.getIndirectEmployees.find((e: { id: any; }) => e.id === this.selectedEmployeeId);
      if (!isSelectedStillInList && this.getIndirectEmployees.length > 0) {
        this.selectedEmployeeId = this.getIndirectEmployees[0].id;
      }

      if (this.selectedSubTab == 'Dashboard') {
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
          this.selectedEmpIdForDashboard = this.loggedInUserId;
          this.selectedEmpIdForDWMEmpWiseTaskStatus = this.loggedInUserId;
          this.selectedEmpIdForDWMEmpCompletionStatus = this.loggedInUserId;
          this.selectedIdForDWMCount = this.loggedInUserId;
          this.getCountOfMyDailyWork();
        } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
          if (this.getIndirectEmployees.length != 0) {
            this.selectedEmpIdForDashboard = this.selectedEmployeeId;
            this.selectedEmpIdForDWMEmpWiseTaskStatus = this.selectedEmployeeId;
            this.selectedEmpIdForDWMEmpCompletionStatus = this.selectedEmployeeId;
            this.selectedIdForDWMCount = this.selectedEmployeeId;
          }
          this.getCountOfMyDailyWork();
        }
      } else {
        if (this.getIndirectEmployees.length != 0) {
          this.selectedEmpIdForDashboard = this.selectedEmployeeId;
          this.selectedEmpIdForDWMEmpWiseTaskStatus = this.selectedEmployeeId;
          this.selectedEmpIdForDWMEmpCompletionStatus = this.selectedEmployeeId;
          this.selectedIdForDWMCount = this.selectedEmployeeId;
        }
        this.getCountOfMyDailyWork();
      }
    });
  }


  skipInProgress = false;


  onClickSkidDay() {
    // console.log("tasklist...",this.taskList);

    var ids = this.taskList?.map((ele: { id: any; }) => ele.id)
    const successdialogRef = this.dialog.open(ExtendDueDatePopupComponent, {
      disableClose: true,
      height: '25%',
      width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
      maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      data: {
        btn1: "Cancel",
        btn2: 'Skip',
        id: this.selectedEmployeeId,
        skipDate: this.dailyTeamTaskFromDate,
        btn2BgColor: '#F3820E',
        showExtendedDueDate: false,
        showComment: true,
      },
    });
    successdialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.skipDayManagerComment();
      }
    });
  }



  downloadExcel() {
    if (this.selectedTypeTabName == 'Review Meeting') {
      if (this.selectedSubTab == 'Reports') {
        if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.excelDownloadReportAssignedTasks();
        } else {
          if (this.selectedReportOf == 'My Task') {
            this.excelDownloadReportMyTasks();
          } else {
            this.excelDownloadReportAssignedTasks();
          }
        }
      } else if (this.selectedSubTab == 'Employee Task') {
        this.excelDownloadReportAssignedTasks();
      } else {
        this.excelDownloadAssignedTasks();
      }
    } else {
      if (this.selectedSubTab == 'Reports') {
        if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.excelDownloadTeamDWMReport();
        } else {
          if (this.selectedReportOf == 'My DWM') {
            this.excelDownloadMyDWReport();
          } else {
            this.excelDownloadTeamDWMReport();
          }
        }
      } else {
        if (this.selectedSubTab == 'Employee DWM') {
          this.excelDownloadEmployeeDWMTasks();
        } else {
          this.excelDownloadTeamDWM();
        }
      }
    }
  }



  downloadPdf() {
    if (this.selectedTypeTabName == 'Review Meeting') {
      if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        || this.loggedInUserRole == 'PHI Admin') {
        this.assignedTasksTaskReportPDF();
      } else {
        if (this.selectedReportOf == 'My Task') {
          this.assignedTasksMyTaskReportPDF();
        }
        else {
          this.assignedTasksTaskReportPDF();
        }
      }
    } else {
      if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
        || this.loggedInUserRole == 'PHI Admin') {
        this.dwmReportPDF();
      } else {
        if (this.selectedReportOf == 'My Task') {
          this.mydwmReportPDF();
        } else {
          this.dwmReportPDF();
        }
      }
    }
  }




  excelDownloadAssignedTasks() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My Task') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee Task') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.loggedInUserId)
      userType = 2;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "search": this.searchString,
        "taskStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "userType": userType
      }
      this.httpService.callPostService(this.config.excelDownloadAssignedTasks2, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL)
          saveAs(data?.fileUrl, fileName[1]);
        }
      })
    }
  }
  excelDownloadMyTasks() {
    var ids = [];
    ids.push(this.loggedInUserId);
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "id": ids
    }
    this.httpService.callPostService(this.config.excelDownloadMyTasks, request).subscribe((data: any) => {
      if (data?.fileUrl != null) {
        var fileName = data?.fileUrl?.split(environment.downloadURL)
        saveAs(data?.fileUrl, fileName[1]);
      }
    })
  }
  excelDownloadReportAssignedTasks() {
    var ids = [];
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin') {
      ids = this.selectedEmployeeIdForReport?.map((ele: { id: any; }) => ele.id)
    } else {
      if (this.selectedReportOf == 'My Task') {
        ids.push(this.loggedInUserId);
      } else {
        ids = this.selectedEmployeeIdForReport?.map((ele: { id: any; }) => ele.id)
      }
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.excelDownloadReportAssignedTasks, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL)
          saveAs(data?.fileUrl, fileName[1]);
        }
      })
    }
  }
  excelDownloadReportMyTasks() {
    var ids = [];
    if (this.selectedReportOf == 'My Task') {
      ids = this.loggedInUserId;
    } else {
      ids = this.selectedEmployeeIdForReport?.map((ele: { id: any; }) => ele.id)
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.excelDownloadReportMyTasks, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL)
          saveAs(data?.fileUrl, fileName[1]);
        }
      })
    }
  }
  excelDownloadTeamDWM() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My DWM') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee DWM') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.selectedEmployeeId)
      userType = 2;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": ids,
      "search": this.searchString,
      "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "userType": userType
    }
    this.httpService.callPostService(this.config.excelgetAllTaskDownload, request).subscribe((data: any) => {
      if (data?.fileUrl != null) {
        var fileName = data?.fileUrl?.split(environment.downloadURL)
        saveAs(data?.fileUrl, fileName[1]);
      }
    })
  }
  excelDownloadMyDWM() {
    var ids = [];
    ids.push(this.loggedInUserId);
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "id": ids
    }
    this.httpService.callPostService(this.config.excelDownloadMyDWM, request).subscribe((data: any) => {
      if (data?.fileUrl != null) {
        var fileName = data?.fileUrl?.split(environment.downloadURL)
        saveAs(data?.fileUrl, fileName[1]);
      }
    })
  }
  excelDownloadMyDWReport() {
    var employeeIds = [];
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin') {
      employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
    } else {
      if (this.selectedReportOf == 'My DWM') {
        employeeIds = [this.loggedInUserId]
      } else {
        employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
      }
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": employeeIds,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "search": this.searchString,
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "type": this.selectedReportOf
      };
      this.httpService.callPostService(this.config.excelDownloadTeamDWMReports, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL)
          saveAs(data?.fileUrl, fileName[1]);
        }
      })
    }
  }
  excelDownloadTeamDWMReport() {
    var employeeIds = [];
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin') {
      employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
    } else {
      if (this.selectedReportOf == 'My DWM') {
        employeeIds = [this.loggedInUserId]
      } else {
        employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
      }
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": employeeIds,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "search": this.searchString,
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "type": this.selectedReportOf
      };
      this.httpService.callPostService(this.config.excelDownloadTeamDWMReports, request).subscribe((data: any) => {
        if (data?.fileUrl != null) {
          var fileName = data?.fileUrl?.split(environment.downloadURL)
          saveAs(data?.fileUrl, fileName[1]);
        }
      })
    }
  }


  ///-------------------------------- pdf download ----------------
  dwmReportPDF() {
    var employeeIds = [];
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin') {
      employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
    } else {
      if (this.selectedReportOf == 'My DWM') {
        employeeIds = [this.loggedInUserId]
      } else {
        employeeIds = this.selectedEmployeeIdForReport.map((ele: { id: any; }) => ele.id)
      }
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": employeeIds,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "type": this.selectedReportOf
      }
      this.httpService.callPostService(this.config.assignedTasksMyTaskReportPDFGenerator, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]);
        }
      })
    }
  }
  mydwmReportPDF() {
    var ids = [];
    if (this.selectedReportOf == 'My DWM') {
      ids.push(this.loggedInUserId);
    } else {
      ids = this.selectedEmployeeIdForReport?.map((ele: { id: any; }) => ele.id)

    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "type": this.selectedReportOf
      }
      this.httpService.callPostService(this.config.assignedTasksMyTaskReportPDFGenerator, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]);
        }
      })
    }
  }

  assignedTasksMyTaskReportPDF() {
    var ids = this.loggedInUserId;

    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }

      this.httpService.callPostService(this.config.assignedTasksMyTaskReportPDF, request).subscribe({
        next: (data: any) => {
          if (data?.data != null) {
            var fileName = data?.data?.split(environment.downloadURL);
            saveAs(data?.data, fileName[1]);
          } else {
            this.toastr.error("No data found");
          }
        },
        error: (error: any) => {
          console.error("Error response ===>", error);
          if (error.status === 404 && error.error?.message) {
            this.toastr.error(error.error.message);
          } else {
            this.toastr.error('Something went wrong. Please try again.');
          }
        }
      });
    }
  }


  assignedTasksTaskReportPDF() {
    var ids = [];
    ids = this.selectedEmployeeIdForReport?.map((ele: { id: any; }) => ele.id);
    // console.log("Selected Employees..", this.selectedEmployeeIdForReport);

    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": ids,
        "search": this.searchString,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }

      this.httpService.callPostService(this.config.assignedTasksTaskReportPDF, request).subscribe({
        next: (data: any) => {

          if (data?.data != null) {
            var fileName = data?.data?.split(environment.downloadURL)


            saveAs(data?.data, fileName[1]);
          } else {
            this.toastr.error("No data found");
          }
        },
        error: (error: any) => {
          console.error("Error response ===>", error);
          if (error.status === 404 && error.error?.message) {
            this.toastr.error(error.error.message);
          } else {
            this.toastr.error('Something went wrong. Please try again.');
          }
        }
      });
    }
  }



  onSelectSingleSelectDashoard() {
    this.getEmployeeWiseTaskStatus();
  }
  selectAllEmpForDashboard(event: any) {
    this.selectedMultiEmployeeIdForDashboard = event;
    this.getEmployeeWiseTaskStatus();
  }
  onDeSelectAllEmpForDashboard() {
    this.selectedMultiEmployeeIdForDashboard = [];
    this.getEmployeeWiseTaskStatus();
  }

  onDateChangeDashboard() {
    if (this.taskFromDate != null && this.taskToDate != null) {
      if (this.selectedTypeTabName == 'Review Meeting' && this.selectedSubTab == 'Dashboard') {
        this.taskAssignedByMeFromDate = this.taskFromDate;
        this.taskAssignedByMeToDate = this.taskToDate;
        this.taskAssignedToMeFromDate = this.taskFromDate;
        this.taskAssignedToMeToDate = this.taskToDate;
        this.employeeStatusFromDate = this.taskFromDate;
        this.employeeStatusToDate = this.taskToDate;
        this.employeeTaskFromDate = this.taskFromDate;
        this.employeeTaskToDate = this.taskToDate;
        this.employeeExtentionFromDate = this.taskFromDate;
        this.employeeExtentionToDate = this.taskToDate;
        this.myComingWeekTaskFromDate = this.taskFromDate;
        this.myComingWeekTaskToDate = this.taskToDate;
        this.allocatedTaskFromDate = this.taskFromDate;
        this.allocatedTaskToDate = this.taskToDate;
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
          this.getAllEmployeeDropdownByCompanyID();
        } else if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          this.getIndirectEmployeesList();
        } else if (this.loggedInUserRole == 'Employee') {
          this.isUserEmployee = true;
          this.selectedEmpIdForDashboard = this.loggedInUserId;
          this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId,
            this.selectedEmpIdForEmpWiseTask = this.loggedInUserId,
            this.selectedEmpIdForEmpWiseTaskWithExtention = this.loggedInUserId;
          this.selectedEmpIdForDWMEmpWiseTaskStatus = this.loggedInUserId;
          this.selectedEmpIdForDWMEmpCompletionStatus = this.loggedInUserId;
        }
        this.taskAssignedByMeFunction();
        this.taskAssignedToMeFunction();
        this.getEmployeeWiseTaskStatus();
        this.getEmployeeWiseTask();
        this.getEmployeeWiseTasksWithExtensions();
        this.onDateChangeAllocatedTask();
        this.onDateChangeMyComingWeekTask();
      } else if (this.selectedTypeTabName == 'Daily Work Management' && this.selectedSubTab == 'Dashboard') {
        if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
          || this.loggedInUserRole == 'PHI Admin') {
          this.getAllEmployeeDropdownByCompanyID();
        }
        if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
          this.getTeamOfManager();
        }
        this.dwmEmpWiseTaskStatusFormDate = this.taskFromDate;
        this.dwmEmpWiseTaskStatusToDate = this.taskToDate;
        this.dwmCompletionStatusFormDate = this.taskFromDate;
        this.dwmCompletionStatusToDate = this.taskToDate;
        this.dwmDashboardCounts();
        this.getDWMEmployeeWiseTaskStatus()
        this.getcountOfEmployeeWiseTaskCompletionStatus();
      }
    }
  }
  onDownloadTskAssignedByMe() {

  }
  onDateChangetaskAssignedByMe() {
    var id
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.taskAssignedByMeFromDate != null && this.taskAssignedByMeToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromDate": this.datePipe.transform(this.taskAssignedByMeFromDate, 'yyyy-MM-dd'),
        "managerId": id,
        "toDate": this.datePipe.transform(this.taskAssignedByMeToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.taskedAssignedByManager, request).subscribe((data: any) => {
        this.getTaskedAssignedByMeData = [];
        this.getTaskedAssignedByMeData.push({
          name: 'Completed Task',
          value: data?.data?.completedTask,
        }, {
          name: 'Total Task',
          value: data?.data?.totalTask,
        })
        this.taskAssignedByMe();
      })
    }
  }
  taskAssignedByMeFunction() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "managerId": id,
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.taskedAssignedByManager, request).subscribe((data: any) => {
        this.getTaskedAssignedByMeData = [];
        this.getTaskedAssignedByMeData.push({
          name: 'Completed Task',
          value: data?.data?.completedTask,
        }, {
          name: 'Total Task',
          value: data?.data?.totalTask,
        })
        this.taskAssignedByMe();
      })
    }
  }


  // taskAssignedByMe() {
  //   function generateCenterText(data: any) {
  //     return (`${data[0].value}` + ' Completed / ' + `${data[1].value}`)
  //   }
  //   var option;
  //   var dom = document.getElementById("taskAssignedByMe");
  //   var myChart = echarts.init(dom);
  //   option = {
  //     title: {
  //       left: 'center',
  //       top: '20px',
  //       textStyle: {
  //         fontSize: 20
  //       }
  //     },
  //     tooltip: {
  //       trigger: 'item',
  //     },
  //     series: [
  //       {
  //         type: 'pie',
  //         radius: ['40%', '70%'],
  //         center: ['50%', '50%'],
  //         startAngle: 180,
  //         endAngle: 360,
  //         data: [
  //           { value: this.getTaskedAssignedByMeData[0].value, itemStyle: { color: '#393186' } },  // Highlight completed
  //           { value: this.getTaskedAssignedByMeData[1].value - this.getTaskedAssignedByMeData[0].value, itemStyle: { color: '#DDDDDD' } }
  //         ],
  //         label: {
  //           show: false,  // Hide the labels
  //         },
  //         emphasis: {
  //           itemStyle: {
  //             shadowBlur: 10,
  //             shadowOffsetX: 0,
  //             shadowColor: 'rgba(0, 0, 0, 0.5)'
  //           }
  //         },
  //         itemStyle: {
  //           borderWidth: 0,
  //         }
  //       }
  //     ],
  //     graphic: {
  //       elements: [
  //         {
  //           type: 'text',
  //           left: 'center',
  //           top: 'center',
  //           style: {
  //             text: generateCenterText(this.getTaskedAssignedByMeData),
  //             textAlign: 'center',
  //             fill: '#000',
  //             font: 'bold 12px sans-serif'
  //           }
  //         }
  //       ]
  //     }
  //     // color: ['#393186', '#DDDDDD'],
  //     // tooltip: {
  //     //   trigger: 'item'
  //     // },
  //     // legend: {
  //     //   top: '5%',
  //     //   left: 'center'
  //     // },
  //     // series: [
  //     //   {
  //     //     name: 'Task Assigned By Me',
  //     //     type: 'pie',
  //     //     radius: ['40%', '70%'],
  //     //     center: ['50%', '50%'],
  //     //     avoidLabelOverlap: false,
  //     //     label: {
  //     //       show: false
  //     //     },
  //     //     // adjust the start and end angle
  //     //     startAngle: 180,
  //     //     endAngle: 360,
  //     //     data: this.getTaskedAssignedByMeData
  //     //   }
  //     // ],
  //     // graphic: {
  //     //   elements: [
  //     //     {
  //     //       type: 'text',
  //     //       id: 'center-text',
  //     //       left: 'center',
  //     //       top: 'center',
  //     //       bottom: 'center',
  //     //       style: {
  //     //         text: generateCenterText(this.getTaskedAssignedByMeData), // Set initial text
  //     //         textAlign: 'center',
  //     //         fill: '#000',
  //     //         font: 'bold 12px sans-serif'
  //     //       }
  //     //     }
  //     //   ]
  //     // },
  //     // toolbox: {
  //     //   show: true,
  //     //   feature: {
  //     //     dataView: { show: false, readOnly: false },
  //     //     magicType: { show: false, type: ['line', 'bar'] },
  //     //     restore: { show: false },
  //     //     saveAsImage: { show: false }
  //     //   },
  //     //   iconStyle: { borderColor: '#F3820E' }
  //     // },
  //   };
  //   if (option && typeof option === "object") {
  //     myChart.setOption(option, true);
  //   }
  // }


  taskAssignedByMe() {
    setTimeout(() => {
      const dom = document.getElementById("taskAssignedByMe");
      if (!dom) {
        console.error("Chart container not found");
        return;
      }

      const generateCenterText = (data: any) => {
        return `${data[0].value} Completed / ${data[1].value}`;
      };

      const myChart = echarts.init(dom);
      const option = {
        title: {
          left: 'center',
          top: '20px',
          textStyle: {
            fontSize: 20
          }
        },
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '50%'],
            startAngle: 180,
            endAngle: 360,
            data: [
              { value: this.getTaskedAssignedByMeData[0].value, itemStyle: { color: '#393186' } },
              {
                value: this.getTaskedAssignedByMeData[1].value - this.getTaskedAssignedByMeData[0].value,
                itemStyle: { color: '#DDDDDD' }
              }
            ],
            label: { show: false },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            itemStyle: { borderWidth: 0 }
          }
        ],
        graphic: {
          elements: [
            {
              type: 'text',
              left: 'center',
              top: 'center',
              style: {
                text: generateCenterText(this.getTaskedAssignedByMeData),
                textAlign: 'center',
                fill: '#000',
                font: 'bold 12px sans-serif'
              }
            }
          ]
        }
      };

      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    }, 0); // or try 100ms if needed
  }


  onDownloadTskAssignedToMe() {
    const fromDate = this.datePipe.transform(this.taskAssignedToMeFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.taskAssignedToMeToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';
    this.pdfDownload.taskManagementGraphPDFdownload(
      'taskAssignedToMe1', // chartId
      '', // tableId
      'Task Assigned To Me', // Title
      formattedDate, // Date
      null, // Employee name
      null, // Task
    );
  }

  onDateChangetaskAssignedToMe() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.taskAssignedToMeFromDate != null && this.taskAssignedToMeToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromDate": this.datePipe.transform(this.taskAssignedToMeFromDate, 'yyyy-MM-dd'),
        "employeeId": id,
        "toDate": this.datePipe.transform(this.taskAssignedToMeToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.taskedAssignedToManager, request).subscribe((data: any) => {
        this.getTaskedAssignedByToData = [];
        this.getTaskedAssignedByToData.push({
          name: 'Completed Task',
          value: data?.data?.completedTask,
        },
          {
            name: 'Total Task',
            value: data?.data?.totalTask,
          })
        this.taskAssignedToMe();
      })
    }
  }
  taskAssignedToMeFunction() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "employeeId": id,
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.taskedAssignedToManager, request).subscribe((data: any) => {
        this.getTaskedAssignedByToData = [];
        this.getTaskedAssignedByToData.push({
          name: 'Completed Task',
          value: data?.data?.completedTask,
        },
          {
            name: 'Total Task',
            value: data?.data?.totalTask,
          })
        this.taskAssignedToMe();
      })
    }
  }
  taskAssignedToMe() {
    function generateCenterText(data: any) {
      return (`${data[0].value}` + ' Completed / ' + `${data[1].value}`)
    }
    var option;
    var dom = document.getElementById("taskAssignedToMe1");
    if (!dom) {
      console.error("Dom element not found:taskAssignedToMe1");
      return;
    }
    var myChart = echarts.init(dom);
    option = {
      title: {
        left: 'center',
        top: '20px',
        textStyle: {
          fontSize: 20
        }
      },
      tooltip: {
        trigger: 'item',
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          center: ['50%', '50%'],
          startAngle: 180,
          endAngle: 360,
          data: [
            { value: this.getTaskedAssignedByToData[0].value, itemStyle: { color: '#393186' } },  // Highlight completed
            { value: this.getTaskedAssignedByToData[1].value - this.getTaskedAssignedByToData[0].value, itemStyle: { color: '#DDDDDD' } }
          ],
          label: {
            show: false,  // Hide the labels
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          itemStyle: {
            borderWidth: 0,
          }
        }
      ],
      graphic: {
        elements: [
          {
            type: 'text',
            left: 'center',
            top: 'center',
            style: {
              text: generateCenterText(this.getTaskedAssignedByToData),
              textAlign: 'center',
              fill: '#000',
              font: 'bold 12px sans-serif'
            }
          }
        ]
      }
      // color: ['#393186', '#DDDDDD'],
      // tooltip: {
      //   trigger: 'item'
      // },
      // legend: {
      //   top: '5%',
      //   left: 'center'
      // },
      // series: [
      //   {
      //     name: 'Access From',
      //     type: 'pie',
      //     radius: ['40%', '70%'],
      //     center: ['50%', '50%'],
      //     avoidLabelOverlap: false,
      //     label: {
      //       show: false
      //     },
      //     // adjust the start and end angle
      //     startAngle: 180,
      //     endAngle: 360,
      //     data: this.getTaskedAssignedByToData
      //   }
      // ],
      // graphic: {
      //   elements: [
      //     {
      //       type: 'text',
      //       id: 'center-text',
      //       left: 'center',
      //       top: 'center',
      //       bottom: 'center',
      //       style: {
      //         text: generateCenterText(this.getTaskedAssignedByToData), // Set initial text
      //         textAlign: 'center',
      //         fill: '#000',
      //         font: 'bold 12px sans-serif'
      //       }
      //     }
      //   ]
      // },
      // toolbox: {
      //   show: true,
      //   feature: {
      //     dataView: { show: false, readOnly: false },
      //     magicType: { show: false, type: ['line', 'bar'] },
      //     restore: { show: false },
      //     saveAsImage: { show: false }
      //   },
      //   iconStyle: { borderColor: '#F3820E' }
      // },
    };
    if (option && typeof option === "object") {
      myChart.setOption(option, true);
    }
  }
  onChangeEmpWiseTaskStatusByDateEmpId() {
    if (this.employeeStatusFromDate != null && this.employeeStatusToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskStatus],
        "fromDate": this.datePipe.transform(this.employeeStatusFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeStatusToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.getcountOfTaskAssignedWithSatatusGraph, request).subscribe((data: any) => {
        this.getEmployeeWiseTaskStatusDataForBar = [];
        this.getEmployeeWiseTaskStatusDataForBar.push(
          {
            name: 'Total',
            value: data?.data?.total ? data?.data?.total : 0,
          },
          {
            name: 'Completed',
            value: data?.data?.completed ? data?.data?.completed : 0,
          },
          {
            name: 'Incomplete & EXPD',
            value: data?.data?.perform ? data?.data?.perform : 0,
          },
          {
            name: 'Not Started',
            value: data?.data?.incomplete ? data?.data?.incomplete : 0,
          },
          {
            name: 'Partially Completed',
            value: data?.data?.pending ? data?.data?.pending : 0,
          },
        )
        this.getEmployeeWiseTaskStatusDataForPie = [];
        this.getEmployeeWiseTaskStatusDataForPie.push(
          {
            name: 'Completed',
            value: data?.data?.completed ? data?.data?.completed : 0,
          },
          {
            name: 'Incomplete & EXPD',
            value: data?.data?.perform ? data?.data?.perform : 0,
          },
          {
            name: 'Not Started',
            value: data?.data?.incomplete ? data?.data?.incomplete : 0,
          },
          {
            name: 'Partially Completed',
            value: data?.data?.pending ? data?.data?.pending : 0,
          },
        )
        this.chartOptionsEmpTaskStatus.bar = this.getBarGraphOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForBar);
        this.chartOptionsEmpTaskStatus.pie = this.getPieChartOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForPie);
        // this.setChartType('bar');
        this.initChart();
      })
    }
  }
  getEmployeeWiseTaskStatus() {
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskStatus || this.selectedEmployeeId],
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.getcountOfTaskAssignedWithSatatusGraph, request).subscribe((data: any) => {
        this.getEmployeeWiseTaskStatusDataForBar = [];
        this.getEmployeeWiseTaskStatusDataForPie = [];
        this.getEmployeeWiseTaskStatusDataForBar.push(
          {
            name: 'Total',
            value: data?.data?.total ? data?.data?.total : 0,
          },
          {
            name: 'Completed',
            value: data?.data?.completed ? data?.data?.completed : 0,
          },
          {
            name: 'Incomplete & EXPD',
            value: data?.data?.perform ? data?.data?.perform : 0,
          },
          {
            name: 'Not Started',
            value: data?.data?.incomplete ? data?.data?.incomplete : 0,
          },
          {
            name: 'Partially Completed',
            value: data?.data?.pending ? data?.data?.pending : 0,
          },
        )
        this.getEmployeeWiseTaskStatusDataForPie.push(
          {
            name: 'Completed',
            value: data?.data?.completed ? data?.data?.completed : 0,
          },
          {
            name: 'Incomplete & EXPD',
            value: data?.data?.perform ? data?.data?.perform : 0,
          },
          {
            name: 'Not Started',
            value: data?.data?.incomplete ? data?.data?.incomplete : 0,
          },
          {
            name: 'Partially Completed',
            value: data?.data?.pending ? data?.data?.pending : 0,
          },
        )
        this.chartOptionsEmpTaskStatus.bar = this.getBarGraphOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForBar);
        this.chartOptionsEmpTaskStatus.pie = this.getPieChartOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForPie);
        // this.setChartType('bar');
        this.initChart();
      })
    }
  }
  ngAfterViewInit() {
    this.initChart();
  }
  initChart() {
    setTimeout(() => {
      const dom = document.getElementById('empTaskStatus') as HTMLDivElement;
      if (dom) {
        this.chartEmpTaskStatus = echarts.init(dom);
        this.setChartType('bar'); // Set default chart type
        this.mobileResponsiveService.chartResizeFn(this.chartEmpTaskStatus);
      } else {
        console.warn('Chart DOM element not found: #empTaskStatus');
      }
    }, 1500);
  }

  setChartType(type: any) {
    this.empWiseTaskStatusGraphType = type;
    this.showEmpWiseStatusTble = false;
    const dom = document.getElementById("empTaskStatus") as HTMLDivElement
    this.chartEmpTaskStatus = echarts.init(dom);
    if (!this.chartEmpTaskStatus) {
      console.error("Chart element not found:chartEmpTaskStatus");
      return;
    }
    if (this.chartEmpTaskStatus) {
      if (type == 'bar') {
        this.getBarGraphOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForBar)
      }
      if (type == 'pie') {
        this.getPieChartOptionForEmpWiseTaskStatus(this.getEmployeeWiseTaskStatusDataForPie);
      }
      if (this.chartOptionsEmpTaskStatus[type] && typeof this.chartOptionsEmpTaskStatus[type] === "object") {
        this.chartEmpTaskStatus.setOption(this.chartOptionsEmpTaskStatus[type], true);
      }
    }
    this.mobileResponsiveService.chartResizeFn(this.chartEmpTaskStatus);
  }
  getBarGraphOptionForEmpWiseTaskStatus(data: any): echarts.EChartsOption {
    return {
      color: ['#F3820E'],
      tooltip: { trigger: 'axis' },
      xAxis: {
        type: 'category',
        data: data.map((ele: { name: any; }) => ele.name),
        axisLabel: {
          formatter: function (value) {
            return value.split(' ').join('\n'); // Example of wrapping by spaces
          },
        }
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false // ❌ This disables horizontal lines
        }
      },
      series: [
        {
          data: data.map((ele: { value: any; }) => ele.value),
          type: 'bar',
          barWidth: '20%',
          label: { show: true, position: 'top', fontSize: 9 }
        }
      ],
      grid: {
        top: '15%',
        left: '1%',
        right: '0%',
        bottom: '10%',
        containLabel: true
      },
      toolbox: {
        show: true,
        feature: {
          saveAsImage: { show: false, }
        },
        iconStyle: { borderColor: '#F3820E' }
      },
    };
  }
  getPieChartOptionForEmpWiseTaskStatus(data: any): echarts.EChartsOption {
    // Check if all values are zero
    const allZero = data.every((item: { value: number; }) => item.value === 0);

    if (allZero) {
      // Return an empty object or a placeholder option
      return {
        title: {
          text: 'No data available',
          left: 'center',
          top: 'center',
          textStyle: {
            fontSize: 20,
            color: '#999'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: 'No data available'
        },
        series: [] // No series data to display
      };
    }
    return {
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      series: [
        {
          name: 'Task Status',
          type: 'pie',
          radius: '50%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: data
        }
      ],
      toolbox: {
        show: true,
        feature: { saveAsImage: { show: false } },
        iconStyle: { borderColor: '#F3820E' }
      },
      xAxis: { show: false },
      yAxis: { show: false }
    };
  }
  onClickTableEmpWiseStats() {
    this.empWiseTaskStatusGraphType = ''
    this.showEmpWiseStatusTble = true;
  }
  downloadEmpWuiseTask() {
    if (this.employeeTaskFromDate != null && this.employeeTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTask],
        "fromDate": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.downloadEmpWiseTaskReport, request).subscribe((data: any) => {
        saveAs(data?.data, "EmployeeWiseTask.pdf");
      });
    }
  }
  onChangeEmpWiseTaskByDateEmpId() {
    if (this.employeeTaskFromDate != null && this.employeeTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTask],
        "fromDate": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeewisetasks, request).subscribe((data: any) => {
        this.employeeWiseTaskStatusData = [];
        for (let i = 0; i < data?.data?.response?.length; i++) {
          let status = null
          if (data?.data?.response[i].status == 'IncompleteAndEXPD') {
            status = 'Incomplete & EXPD'
          }
          if (data?.data?.response[i].status == 'PartiallyCompleted') {
            status = 'Partially Completed'
          }
          if (data?.data?.response[i].status == 'Completed') {
            status = 'Completed'
          }
          if (data?.data?.response[i].status == 'NotStarted') {
            status = 'Not Started'
          }
          this.employeeWiseTaskStatusData.push({
            actionable: data?.data?.response[i].actionable,
            status: status,
            percentageOfTaskCompletion: data?.data?.response[i].percentageOfTaskCompletion,
          })
        }
      })
    }
  }
  getEmployeeWiseTask() {
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForDashboard],
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeewisetasks, request).subscribe((data: any) => {
        this.employeeWiseTaskStatusData = [];
        for (let i = 0; i < data?.data?.response?.length; i++) {
          let status = null;
          if (data?.data?.response[i].status == 'IncompleteAndEXPD') {
            status = 'Incomplete & EXPD'
          }
          if (data?.data?.response[i].status == 'PartiallyCompleted') {
            status = 'Partially Completed'
          }
          if (data?.data?.response[i].status == 'Completed') {
            status = 'Completed'
          }
          if (data?.data?.response[i].status == 'NotStarted') {
            status = 'Not Started'
          }
          this.employeeWiseTaskStatusData.push({
            actionable: data?.data?.response[i].actionable,
            status: status,
            percentageOfTaskCompletion: data?.data?.response[i].percentageOfTaskCompletion,
          })
        }
      })
    }
  }
  onSortAsseEmpWiseTask(name: any) {
    if (this.employeeTaskFromDate != null && this.employeeTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTask],
        "fromDate": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeewisetasks + '?page=' + 0 + '&sort=' + name + ',asc', request).subscribe((data: any) => {
        this.employeeWiseTaskStatusData = [];
        for (let i = 0; i < data?.data?.response?.length; i++) {
          let status = null;
          if (data?.data?.response[i].status == 'IncompleteAndEXPD') {
            status = 'Incomplete & EXPD'
          }
          if (data?.data?.response[i].status == 'PartiallyCompleted') {
            status = 'Partially Completed'
          }
          if (data?.data?.response[i].status == 'Completed') {
            status = 'Completed'
          }
          if (data?.data?.response[i].status == 'NotStarted') {
            status = 'Not Started'
          }
          this.employeeWiseTaskStatusData.push({
            actionable: data?.data?.response[i].actionable,
            status: status,
            percentageOfTaskCompletion: data?.data?.response[i].percentageOfTaskCompletion,
          })
        }
      })
    }
  }
  onSortDeseEmpWiseTask(name: any) {
    if (this.employeeTaskFromDate != null && this.employeeTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTask],
        "fromDate": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeewisetasks + '?page=' + 0 + '&sort=' + name + ',desc', request).subscribe((data: any) => {
        this.employeeWiseTaskStatusData = [];
        for (let i = 0; i < data?.data?.response?.length; i++) {
          let status = null;
          if (data?.data?.response[i].status == 'IncompleteAndEXPD') {
            status = 'Incomplete & EXPD'
          }
          if (data?.data?.response[i].status == 'PartiallyCompleted') {
            status = 'Partially Completed'
          }
          if (data?.data?.response[i].status == 'Completed') {
            status = 'Completed'
          }
          if (data?.data?.response[i].status == 'NotStarted') {
            status = 'Not Started'
          }
          this.employeeWiseTaskStatusData.push({
            actionable: data?.data?.response[i].actionable,
            status: status,
            percentageOfTaskCompletion: data?.data?.response[i].percentageOfTaskCompletion,
          })
        }
      })
    }
  }
  downloadEmpTaskWithExtention() {
    if (this.employeeExtentionFromDate != null && this.employeeExtentionToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
        "fromDate": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.downloadEmpTaskExtensionReport, request).subscribe((data: any) => {
        saveAs(data?.data, "EmployeeWiseTaskWithExtention.pdf");
      });
    }
  }
  onChangeEmpWiseTaskWithExtentionDateById() {
    if (this.employeeExtentionFromDate != null && this.employeeExtentionToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
        "fromDate": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeeExtentionWiseTasks, request).subscribe((data: any) => {
        this.employeeExtentionWiseTasksData = []
        for (let i = 0; i < data?.data?.setEmployeeResponse?.length; i++) {
          if (data?.data?.setEmployeeResponse[i].noOfExtensions != 0) {
            let status = null;
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'IncompleteAndEXPD') {
              status = 'Incomplete & EXPD'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'PartiallyCompleted') {
              status = 'Partially Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'Completed') {
              status = 'Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'NotStarted') {
              status = 'Not Started'
            }
            this.employeeExtentionWiseTasksData.push({
              actionable: data?.data?.setEmployeeResponse[i].actionable,
              taskStatus: status,
              noOfExtensions: data?.data?.setEmployeeResponse[i].noOfExtensions,
            })
          }
        }
      })
    }
  }
  getEmployeeWiseTasksWithExtensions() {
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeeExtentionWiseTasks, request).subscribe((data: any) => {
        this.employeeExtentionWiseTasksData = []
        for (let i = 0; i < data?.data?.setEmployeeResponse?.length; i++) {
          if (data?.data?.setEmployeeResponse[i].noOfExtensions != 0) {
            let status = null;
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'IncompleteAndEXPD') {
              status = 'Incomplete & EXPD'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'PartiallyCompleted') {
              status = 'Partially Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'Completed') {
              status = 'Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'NotStarted') {
              status = 'Not Started'
            }
            this.employeeExtentionWiseTasksData.push({
              actionable: data?.data?.setEmployeeResponse[i].actionable,
              taskStatus: status,
              noOfExtensions: data?.data?.setEmployeeResponse[i].noOfExtensions,
            })
          }
        }
      })
    }
  }
  onSortAsseEmpTaskExt(name: any) {
    if (this.employeeExtentionFromDate != null && this.employeeExtentionToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
        "fromDate": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeeExtentionWiseTasks + '?page=' + 0 + '&sort=' + name + ',asc', request).subscribe((data: any) => {
        this.employeeExtentionWiseTasksData = []
        for (let i = 0; i < data?.data?.setEmployeeResponse?.length; i++) {
          if (data?.data?.setEmployeeResponse[i].noOfExtensions != 0) {
            let status = null;
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'IncompleteAndEXPD') {
              status = 'Incomplete & EXPD'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'PartiallyCompleted') {
              status = 'Partially Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'Completed') {
              status = 'Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'NotStarted') {
              status = 'Not Started'
            }
            this.employeeExtentionWiseTasksData.push({
              actionable: data?.data?.setEmployeeResponse[i].actionable,
              taskStatus: status,
              noOfExtensions: data?.data?.setEmployeeResponse[i].noOfExtensions,
            })
          }
        }
      })
    }
  }
  onSortDeseEmpTaskExt(name: any) {
    if (this.employeeExtentionFromDate != null && this.employeeExtentionToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
        "fromDate": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.employeeExtentionWiseTasks + '?page=' + 0 + '&sort=' + name + ',desc', request).subscribe((data: any) => {
        this.employeeExtentionWiseTasksData = []
        for (let i = 0; i < data?.data?.setEmployeeResponse?.length; i++) {
          if (data?.data?.setEmployeeResponse[i].noOfExtensions != 0) {
            let status = null;
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'IncompleteAndEXPD') {
              status = 'Incomplete & EXPD'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'PartiallyCompleted') {
              status = 'Partially Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'Completed') {
              status = 'Completed'
            }
            if (data?.data?.setEmployeeResponse[i].taskStatus == 'NotStarted') {
              status = 'Not Started'
            }
            this.employeeExtentionWiseTasksData.push({
              actionable: data?.data?.setEmployeeResponse[i].actionable,
              taskStatus: status,
              noOfExtensions: data?.data?.setEmployeeResponse[i].noOfExtensions,
            })
          }
        }
      })
    }
  }
  downloadMyComingWeekTask() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.myComingWeekTaskFromDate != null && this.myComingWeekTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": id,
        "fromDate": this.datePipe.transform(this.myComingWeekTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.myComingWeekTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.downloadMyComingWeekTask, request).subscribe((data: any) => {
        saveAs(data?.data, "MyComimngWeekTask.pdf");
      });
    }
  }
  onDateChangeMyComingWeekTask() {
    this.getComingWeekwiseData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.myComingWeekTaskFromDate != null && this.myComingWeekTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": id,
        "fromDate": this.datePipe.transform(this.myComingWeekTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.myComingWeekTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.comingWeekTasks, request).subscribe((data: any) => {
        this.getComingWeekwiseData = data?.data?.setFinalResponse;
      })
    }
  }
  getComingWeekTasks() {
    this.getComingWeekwiseData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    let startOfNextWeek: any = moment().clone().add(1, 'week').startOf('week');
    let endOfNextWeek: any = moment().clone().add(1, 'week').endOf('week');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": id,
      "fromDate": this.datePipe.transform(startOfNextWeek, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(endOfNextWeek, 'yyyy-MM-dd')
    }
    this.httpService.callPostService(this.config.comingWeekTasks, request).subscribe((data: any) => {
      this.getComingWeekwiseData = data?.data?.setFinalResponse;
    })
  }
  onSortAsccomingWeekTasks(name: any) {
    this.getComingWeekwiseData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.myComingWeekTaskFromDate != null && this.myComingWeekTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": id,
        "fromDate": this.datePipe.transform(this.myComingWeekTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.myComingWeekTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.comingWeekTasks + '?page=' + 0 + '&sort=' + name + ',asc', request).subscribe((data: any) => {
        this.getComingWeekwiseData = data?.data?.setFinalResponse;
      })
    }
  }
  onSortDesecomingWeekTasks(name: any) {
    this.getComingWeekwiseData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.myComingWeekTaskFromDate != null && this.myComingWeekTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": id,
        "fromDate": this.datePipe.transform(this.myComingWeekTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.myComingWeekTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.comingWeekTasks + '?page=' + 0 + '&sort=' + name + ',desc', request).subscribe((data: any) => {
        this.getComingWeekwiseData = data?.data?.setFinalResponse;
      })
    }
  }
  downloadAllocatedWeekTask() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.allocatedTaskFromDate != null && this.allocatedTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "managerId": id,
        "fromDate": this.datePipe.transform(this.allocatedTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.allocatedTaskToDate, 'yyyy-MM-dd'),
      }
      this.httpService.callPostService(this.config.downloadMyAllocatedWeekTask, request).subscribe((data: any) => {
        saveAs(data?.data, "AllocatedWeekTask.pdf");
      });
    }
  }
  onDateChangeAllocatedTask() {
    this.allocatedTasksData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.allocatedTaskFromDate != null && this.allocatedTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "managerId": id,
        "fromDate": this.datePipe.transform(this.allocatedTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.allocatedTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.allocatedTaskInWeek, request).subscribe((data: any) => {
        this.allocatedTasksData = data?.data?.finalResponse;
      })
    }
  }
  getAllocatedWeekTasksInWeek() {
    this.allocatedTasksData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    let startOfWeek: any = moment().clone().startOf('week');
    let endOfWeek: any = moment().clone().endOf('week');
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "managerId": id,
      "fromDate": this.datePipe.transform(startOfWeek, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(endOfWeek, 'yyyy-MM-dd')
    }
    this.httpService.callPostService(this.config.allocatedTaskInWeek, request).subscribe((data: any) => {
      this.allocatedTasksData = data?.data?.finalResponse;
    })
  }
  onSortAscAllocatedTask(name: any) {
    this.allocatedTasksData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.allocatedTaskFromDate != null && this.allocatedTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "managerId": id,
        "fromDate": this.datePipe.transform(this.allocatedTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.allocatedTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.allocatedTaskInWeek + '?page=' + 0 + '&sort=' + name + ',asc', request).subscribe((data: any) => {
        this.allocatedTasksData = data?.data?.finalResponse;
      })
    }
  }
  onSortDeseAllocatedTask(name: any) {
    this.allocatedTasksData = [];
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.allocatedTaskFromDate != null && this.allocatedTaskToDate != null) {
      const request = {
        "companyId": this.loggedInUserCompanyID,
        "managerId": id,
        "fromDate": this.datePipe.transform(this.allocatedTaskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.allocatedTaskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.allocatedTaskInWeek + '?page=' + 0 + '&sort=' + name + ',desc', request).subscribe((data: any) => {
        this.allocatedTasksData = data?.data?.finalResponse;
      })
    }
  }
  getDWMTaskActionableList() {
    if (this.dwmEmpWiseTaskStatusFormDate != null && this.dwmEmpWiseTaskStatusToDate != null) {

      if (this.selectedEmpIdForDWMEmpWiseTaskStatus == null && (this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'Employee')) {
        this.selectedEmpIdForDWMEmpWiseTaskStatus = this.loggedInUserId
        return
      }

      const request = {
        "companyId": this.loggedInUserCompanyID,
        "employeeId": this.selectedEmpIdForDWMEmpWiseTaskStatus || this.selectedEmpIdForDashboard,
        "fromDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getActionableListDwm, request).subscribe((data: any) => {
        this.dwmTaskStatusList = data?.data;
        this.dwmTaskStatusList = this.dwmTaskStatusList.sort((a: any, b: any) => a.localeCompare(b));
        this.selectedDWMTaskStatus = this.dwmTaskStatusList[0];
        this.onChangeSelectedDWMEmpWiseTaskStatusByIdDate();
      })
    }
  }
  onDownloadDWMEmpWiseTaskStatus() {

  }
  onChangeSelectedDWMEmpWiseTaskStatusByIdDate() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      id = this.selectedEmpIdForDWMEmpWiseTaskStatus;
    }
    if (this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    if (this.dwmEmpWiseTaskStatusFormDate != null && this.dwmEmpWiseTaskStatusToDate != null) {
      const request = {
        "actionable": [this.selectedDWMTaskStatus],
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [id],
        "fromDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getEmployeeWiseTaskStatus, request).subscribe((data: any) => {
        this.dwmEmpWiseTaskStatusData = data?.data?.setDailyResponse;
      })
    }
  }
  onChangeSelectedDWMEmpWiseTaskStatusByTaskStatus() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      id = this.selectedEmpIdForDWMEmpWiseTaskStatus;
    }
    if (this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    if (this.dwmEmpWiseTaskStatusFormDate != null && this.dwmEmpWiseTaskStatusToDate != null) {
      const request = {
        "actionable": [this.selectedDWMTaskStatus],
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [id],
        "fromDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getEmployeeWiseTaskStatus, request).subscribe((data: any) => {
        this.dwmEmpWiseTaskStatusData = data?.data?.setDailyResponse;
      })
    }
  }
  getDWMEmployeeWiseTaskStatus() {
    this.getDWMTaskActionableList();
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      console.log(this.getIndirectEmployees);
      let findId = this.getIndirectEmployees[0]


      id = this.selectedEmpIdForDWMEmpWiseTaskStatus || findId.id;
    }
    if (this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "actionable": [this.selectedDWMTaskStatus],
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [id],
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.getEmployeeWiseTaskStatus, request).subscribe((data: any) => {
        this.dwmEmpWiseTaskStatusData = data?.data?.setDailyResponse;
      })
    }
  }
  onDownloadDWMTaskCompletionStatus() {

  }
  onChangeEmpCompletionStatusByIdDate() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.selectedEmpIdForDWMEmpCompletionStatus;
    }
    if (this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": [id],
      "toDate": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd'),
    }
    this.httpService.callPostService(this.config.getcountOfEmployeeWiseTaskCompletionStatus, request).subscribe((data: any) => {
      this.getEmployeeWiseDWMTaskStatus = [];
      this.getEmployeeWiseDWMTaskStatus.push(
        {
          name: 'Completed',
          value: data?.data?.completed == 0 ? null : data?.data?.completed,
        },
        {
          name: 'Incomplete',
          value: data?.data?.incomplete == 0 ? null : data?.data?.incomplete,
        },
      )
      this.dwmCompletionsStatus();
    })
  }
  getcountOfEmployeeWiseTaskCompletionStatus() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {

      if (this.selectedEmpIdForDWMEmpCompletionStatus == null) {
        id = this.selectedEmpIdForDashboard
      }else if(this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD'){
        id=this.selectedEmpIdForDashboard
      }
       else {
        id = this.loggedInUserId;
      }
    }
    if (this.loggedInUserRole == 'Employee') {
      id = this.loggedInUserId;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": [id],
      "toDate": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd') || this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
    }
    this.httpService.callPostService(this.config.getcountOfEmployeeWiseTaskCompletionStatus, request).subscribe((data: any) => {
      this.getEmployeeWiseDWMTaskStatus = [];
      this.getEmployeeWiseDWMTaskStatus.push(
        {
          name: 'Completed',
          value: data?.data?.completed == 0 ? null : data?.data?.completed,
        },
        {
          name: 'Incomplete',
          value: data?.data?.incomplete == 0 ? null : data?.data?.incomplete,
        },
      )
      this.dwmCompletionsStatus();
    })
  }
  // dwmCompletionsStatus() {
  //   var option1;
  //   var dom = document.getElementById("dwmCompletionsStatuss");
  //   var myChart1 = echarts.init(dom);
  //   option1 = {
  //     color: ['#F3820E', '#322B68'],
  //     tooltip: {
  //       trigger: 'item'
  //     },
  //     legend: {
  //       top: '5%',
  //       left: 'center'
  //     },
  //     series: [
  //       {
  //         name: '',
  //         type: 'pie',
  //         radius: '50%',
  //         data: this.getEmployeeWiseDWMTaskStatus,
  //         emphasis: {
  //           itemStyle: {
  //             shadowBlur: 10,
  //             shadowOffsetX: 0,
  //             shadowColor: 'rgba(0, 0, 0, 0.5)'
  //           }
  //         }
  //       }
  //     ],
  //     xAxis: { show: false },
  //     yAxis: { show: false }
  //   };
  //   if (option1 && typeof option1 === "object") {
  //     myChart1.setOption(option1, true);
  //   }
  // }


  dwmCompletionsStatus() {
    setTimeout(() => {
      const dom = document.getElementById("dwmCompletionsStatuss");
      if (!dom) {
        console.error("Chart container not found");
        return;
      }

      const myChart1 = echarts.init(dom);
      const option1 = {
        color: ['#F3820E', '#322B68'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'center'
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '50%',
            data: this.getEmployeeWiseDWMTaskStatus,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ],
        xAxis: { show: false },
        yAxis: { show: false }
      };

      if (option1 && typeof option1 === "object") {
        myChart1.setOption(option1, true);
      }
    }, 0); // or 100ms if still fails
  }

  dwmDashboardCounts() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
      if (this.selectedEmpIdForDashboard == null) {
        id = this.loggedInUserId
      } else {
        id = this.selectedEmpIdForDashboard;
      }
    } else {
      id = this.selectedIdForDWMCount;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "userIds": [id]
      }
      this.httpService.callPostService(this.config.dwmDashboardCounts, request).subscribe((data: any) => {
        this.dashboardCounterModule.forEach((item: any) => {
          if (item.ModuleName == 'No. of days in the period') {
            item.totalCount = data.data?.no_of_working_days;
          } if (item.ModuleName == 'No. of Days Skipped') {
            item.totalCount = data.data?.no_of_days_skipped;
            // console.log("daysss............", item.totalCount);

          } if (item.ModuleName == 'Days of DWM Reviewed') {
            item.totalCount = data.data?.dwm_reviewed;
          } if (item.ModuleName == 'Days of DWM to be Reviewed') {
            item.totalCount = data.data?.dwm_to_be_reviewed;
          }
        })
      })
    }
  }
  onClickDashboardCounter(moduleName: any, totalCount: any) {
    // if (window.innerWidth <= 800) { return; } // uncomment this to Hide below popups on mobile
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HOD') {
      id = this.selectedEmpIdForDashboard;
    } else {
      id = this.selectedIdForDWMCount;
    }
    if (moduleName == 'No. of days in the period') {

    } else if (moduleName == 'No. of Days Skipped') {
      const successdialogRef = this.dialog.open(DwmdashbordCountPopUpComponent, {
        disableClose: true,
        height: '50%',
        // width: '70%',
        width: window.innerWidth <= 576 ? '95%' : '80%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          popupName: moduleName,
          loggedInUserCompanyID: this.loggedInUserCompanyID,
          employeeId: id,
          startDate: this.taskFromDate,
          endDate: this.taskToDate,
          totalCount: totalCount
        },
      });
      successdialogRef.afterClosed().subscribe(result => { });
    } else if (moduleName == 'Days of DWM Reviewed') {
      const successdialogRef = this.dialog.open(DwmdashbordCountPopUpComponent, {
        disableClose: true,
        height: '50%',
        // width: '85%',
        width: window.innerWidth <= 576 ? '95%' : '90%',
        maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
        data: {
          popupName: moduleName,
          loggedInUserCompanyID: this.loggedInUserCompanyID,
          employeeId: id,
          startDate: this.taskFromDate,
          endDate: this.taskToDate,
          totalCount: totalCount
        },
      });
    } else if (moduleName == 'DWM to be reviewed') {
      // const successdialogRef = this.dialog.open(DwmdashbordCountPopUpComponent, {
      //   disableClose: true,
      //   height: '50%',
      //   width: '70%',
      //   maxWidth: this.mobileResponsiveService.modelMaxWidthForMobileDevice,
      //   data: {
      //     popupName: moduleName,
      //     loggedInUserCompanyID: this.loggedInUserCompanyID,
      //     employeeId: this.selectedIdForDWMCount,
      //     startDate:  this.taskFromDate,
      //     endDate: this.taskToDate,
      //     totalCount: totalCount
      //   },
      // });
    }
  }
  onRemoveUploadedFile(item: any, index: number) {
    this.taskList[index].documentAttachment = null;
    this.taskList[index].documentName = null;
    this.onClickEditDWM(index, 'Edit');
  }

  checkLengthOfField(string: any) {
    if (string.length > 254) {
      this.toastr.warning('The text cannot exceed 255 characters.', '', {
        timeOut: 3000,
      });
    }
  }



  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }


  isToggled = false; // Default state of the toggle button

  // Method to handle the change event
  onToggleDWMChange(event: Event, index: any, operation: any): void {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.taskList[index].taskStatus = 'Completed';
      this.taskList[index].taskStatusFlag = true;
    } else {
      this.taskList[index].taskStatus = 'InCompleted';
      this.taskList[index].taskStatusFlag = false;
    }
    if (operation == 'Edit' && !this.showAddNewSaveBtn) {
      this.onClickEditDWM(index, operation)
    }
  }
  isDaySkipped: any = null;
  skipDayManagerComment() {
    var ids = [];
    if (this.selectedSubTab == 'My DWM') {
      ids.push(this.loggedInUserId);
    } else {
      ids.push(this.selectedEmployeeId);
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": ids,
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd')
    }
    this.httpService.callPostService(this.config.skipDayManagerComment, request).subscribe((data: any) => {
      this.isDaySkipped = data?.data?.skipManagerComment || null;
    })
  }
  getCountOfMyDailyWork() {
    var ids = [];
    var userType = 1;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin'
      || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.loggedInUserId);
      userType = 1;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "dwmStatus": this.taskStatusListDWM.map((ele: { id: any; }) => ele.id),
      "employeeId": ids,
      "search": this.searchString,
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "userType": userType
    }
    this.httpService.callPostService(this.config.getCountOfMyDailyWork, request).subscribe((data: any) => {
      this.myDWMCount = data?.assignedMyWorkCount;
    })
  }
  sameActionableAlreayExists: boolean = false;
  actionableCheck(actionable: any) {
    if (actionable.length != 0) {
      const request = {
        "actionable": actionable,
        "companyId": this.loggedInUserCompanyID,
        "employeeId": this.selectedEmployeeId,
        "id": null,
        "managerId": this.loggedInUserId,
        "startDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd')
      }
      this.httpService.callPostService(this.config.actionableCheck, [request]).subscribe((data: any) => {
        if (!data?.status) {
          this.sameActionableAlreayExists = true;
          this.toastr.error('Same Actionable already exists.', '', {
            timeOut: 3000,
          });
        } else {
          this.sameActionableAlreayExists = false;
        }
      })
    }
  }
  getFormattedString(data: any): string {
    return data.length > 10 ? data.substring(0, 10) + '...' : data;
  }
  excelDownloadEmployeeDWMTasks() {
    var ids = [];
    var userType = 1;
    if (this.selectedSubTab == 'My DWM') {
      ids.push(this.loggedInUserId);
      userType = 1;
    } else if (this.selectedSubTab == 'Employee DWM') {
      ids = this.selectedMultiEmployeeId?.map((ele: { id: any; }) => ele.id);
      userType = 1;
    }
    else {
      ids.push(this.selectedEmployeeId)
      userType = 2;
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "employeeId": ids,
      "fromDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "toDate": this.datePipe.transform(this.dailyTeamTaskFromDate, 'yyyy-MM-dd'),
      "search": this.searchString,
      "dwmStatus": this.selectedTaskStatus.map((ele: { id: any; }) => ele.id),
    }
    this.httpService.callPostService(this.config.excelDownloadEmployeeDWMTasks, request).subscribe((data: any) => {
      if (data?.fileUrl != null) {
        var fileName = data?.fileUrl?.split(environment.downloadURL)
        saveAs(data?.fileUrl, fileName[1]);
      }
    })
  }
  getEmployeeOfAdmin() {
    var fromDate
    var toDate
    if (this.selectedTypeTabName == 'Review Meeting') {
      fromDate = this.taskFromDate
      toDate = this.taskToDate
    } else {
      fromDate = this.dailyTeamTaskFromDate
      toDate = this.dailyTeamTaskFromDate
    }
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": [],
      "moduleName": "Task Management",
      "from": this.datePipe.transform(fromDate, 'yyyy-MM-dd'),
      "to": this.datePipe.transform(toDate, 'yyyy-MM-dd'),
      "userId": this.loggedInUserId
    }
    this.httpService.callPostService(this.config.getEmpsOfAdminByDateForTaskMgment, request).subscribe((data: any) => {

      this.getIndirectEmployees = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployees.push(obj);
      });
      this.getIndirectEmployees = this.getIndirectEmployees?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      this.selectedMultiEmployeeId = this.getIndirectEmployees;
      this.selectedEmployeeIdForReport = this.getIndirectEmployees;

      if (this.selectedTypeTabName == 'Review Meeting') {
        if (this.loggedInUserRole == 'Admin') {
          {
            if (this.selectedSubTab == 'Reports') {
              this.taskManagmentReport();
            } else {
              this.getAllTasks();
            }
            this.getCountOfTasks();
          }
        }
      } else {
        if (this.loggedInUserRole == 'Admin') {
          {
            if (this.selectedSubTab == 'Reports') {
              this.taskManagmentReport();
            } else {
              this.getAllDWMTasks();
            }
            this.getCountOfMyDailyWork();
            this.getCountOfDWMWorkTasks();
          }
        }
      }
      if (this.getIndirectEmployees.length != 0) {
        this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id;
        this.selectedEmployeeId = this.getIndirectEmployees[0].id;
        this.selectedEmpIdForDWMEmpWiseTaskStatus = this.getIndirectEmployees[0].id;
        this.selectedEmpIdForDWMEmpCompletionStatus = this.getIndirectEmployees[0].id;
        this.selectedIdForDWMCount = this.getIndirectEmployees[0].id;
        this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployees[0].id,
          this.selectedEmpIdForEmpWiseTask = this.getIndirectEmployees[0].id,
          this.selectedEmpIdForEmpWiseTaskWithExtention = this.getIndirectEmployees[0].id;
      } else {
        this.selectedEmpIdForDashboard = null;
        this.selectedEmployeeId = null;
        this.selectedEmpIdForDWMEmpWiseTaskStatus = null;
        this.selectedEmpIdForDWMEmpCompletionStatus = null;
        this.selectedIdForDWMCount = null;
        this.selectedEmpIdForEmpWiseTaskStatus = null;
        this.selectedEmpIdForEmpWiseTask = null;
        this.selectedEmpIdForEmpWiseTaskWithExtention = null;
      }
    })
  }
  taskManagementDashboardGraphDownloadTaskAssignedByMe() {
    const fromDate = this.datePipe.transform(this.taskAssignedByMeFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.taskAssignedByMeToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    console.warn(formattedDate);

    this.pdfDownload.taskManagementGraphPDFdownload(
      'taskAssignedByMe', // chartId
      '', // tableId
      'Task Assigned by Me', // Title
      formattedDate, // Date
      null, // Employee name
      null, // Task
    );
    // var id;
    // if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
    //   id = this.selectedEmpIdForDashboard;
    // }
    // if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
    //   id = this.loggedInUserId;
    // }
    // if (this.taskFromDate != null && this.taskToDate != null) {
    //   const request = {
    //     "actionable": [],
    //     "companyId": this.loggedInUserCompanyID,
    //     "employeeId": [],
    //     "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
    //     "fromYear": null,
    //     "managerId": id,
    //     "month": null,
    //     "reportName": "TaskAssignedbyMe",
    //     "reportType": "half Donut chart",
    //     "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
    //     "userId": null
    //   }
    //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
    //     if(data?.data!=null){
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]); 
    //     }
    //   })
    // }
  }
  taskManagementDashboardGraphDownloadTaskAssignedToMe() {
    var id;
    if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
      id = this.selectedEmpIdForDashboard;
    }
    if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
      id = this.loggedInUserId;
    }
    if (this.taskFromDate != null && this.taskToDate != null) {
      const request = {
        "actionable": [],
        "companyId": this.loggedInUserCompanyID,
        "employeeId": [id],
        "fromDate": this.datePipe.transform(this.taskFromDate, 'yyyy-MM-dd'),
        "fromYear": null,
        "managerId": null,
        "month": null,
        "reportName": "TaskAssignedtoMe",
        "reportType": "half donut chart",
        "toDate": this.datePipe.transform(this.taskToDate, 'yyyy-MM-dd'),
        "userId": null
      }
      this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
        if (data?.data != null) {
          var fileName = data?.data?.split(environment.downloadURL)
          saveAs(data?.data, fileName[1]);
        }
      })
    }
  }
  taskManagementDashboardGraphDownloadEmpWiseStats() {

    let title: any;
    let selectedEmployeeName: any
    if (this.loggedInUserRole != 'Employee') {
      title = 'Employee-wise Task Status'
    } else {
      title = 'Task Status'
    }
    const fromDate = this.datePipe.transform(this.employeeStatusFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.employeeStatusToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';
    const selectedEmployee = this.getIndirectEmployeesForEmpWiseTaskStatus.find((emp: any) => emp.id === this.selectedEmpIdForEmpWiseTaskStatus);
    if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD) {
      // selectedEmployeeName = 'My Chart'
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : 'My Chart';
    } else {
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
    }

    this.pdfDownload.taskManagementGraphPDFdownload(
      'empTaskStatus', // chartId
      'empTaskStatusTable', // tableId
      title, // Title
      formattedDate, // Date
      selectedEmployeeName || 'My Chart', // Employee name
      null, // Task
    );
    // var reportType;
    // if(this.showEmpWiseStatusTble){
    //   reportType = 'Table chart'
    // }else{
    //   if(this.empWiseTaskStatusGraphType == 'bar'){
    //     reportType ='Bar Graph'
    //   }
    //   if(this.empWiseTaskStatusGraphType == 'line'){
    //     reportType ='line'
    //   }
    //   if(this.empWiseTaskStatusGraphType == 'area'){
    //     reportType ='Area Graph'
    //   }
    //   if(this.empWiseTaskStatusGraphType == 'pie'){
    //     reportType ='Donut Graph'
    //   }
    // }

    // if (this.taskFromDate != null && this.taskToDate != null) {
    //   const request = {
    //     "actionable": [],
    //     "companyId": this.loggedInUserCompanyID,
    //     "employeeId": [this.selectedEmpIdForEmpWiseTaskStatus],
    //     "fromDate": this.datePipe.transform(this.employeeStatusFromDate, 'yyyy-MM-dd'),
    //     "fromYear": null,
    //     "managerId": null,
    //     "month": null,
    //     "reportName": "EmployeewiseTaskStatus",
    //     "reportType": reportType,
    //     "toDate": this.datePipe.transform(this.employeeStatusToDate, 'yyyy-MM-dd'),
    //     "userId": null
    //   }
    //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
    //     if(data?.data!=null){
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]); 
    //     }
    //   })
    // }
  }
  // taskManagementDashboardGraphDownloadEmpWuiseTask() {
  //   let title:any;
  //   let selectedEmployeeName:any
  //   if(this.loggedInUserRole != 'Employee'){
  //     title = 'Employee wise tasks'
  //   }else{
  //     title = 'My tasks'
  //   }
  //   const fromDate = this.datePipe.transform(this.employeeTaskFromDate, 'dd-MM-yyyy');
  //   const toDate = this.datePipe.transform(this.employeeTaskToDate, 'dd-MM-yyyy');
  //   const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

  //   const selectedEmployee = this.getIndirectEmployeesForEmployeeWiseTasks.find((emp:any) => emp.id === this.selectedEmpIdForEmpWiseTask);
  //   if((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD){
  //     selectedEmployeeName = 'My Chart'
  //   }else {
  //      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
  //   }

  //   this.pdfDownload.taskManagementGraphPDFdownload(
  //     null, // chartId
  //     'employeeWiseTasksTable', // tableId
  //     title, // Title
  //     formattedDate, // Date
  //     selectedEmployeeName || 'My Chart', // Employee name
  //     null, // Task
  //   );

  //   // if (this.employeeTaskFromDate != null && this.employeeTaskToDate != null) {
  //   //   const request = {
  //   //     "actionable": [],
  //   //     "companyId": this.loggedInUserCompanyID,
  //   //     "employeeId": [this.selectedEmpIdForEmpWiseTask],
  //   //     "fromDate": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
  //   //     "fromYear": null,
  //   //     "managerId": null,
  //   //     "month": null,
  //   //     "reportName": "Employeewisetasks",
  //   //     "reportType": "table chart",
  //   //     "toDate": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
  //   //     "userId": null
  //   //   }
  //   //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
  //   //     if (data?.data != null) {
  //   //       var fileName = data?.data?.split(environment.downloadURL)
  //   //       saveAs(data?.data, fileName[1]);
  //   //     }
  //   //   })
  //   // }
  // }

  taskManagementDashboardGraphDownloadEmpWuiseTask() {
    let title: any;
    let selectedEmployeeName: any;

    // Set title
    title = this.loggedInUserRole !== 'Employee' ? 'Employee wise tasks' : 'My tasks';

    // Format date range
    const fromDate = this.datePipe.transform(this.employeeTaskFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.employeeTaskToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    // Find selected employee
    const selectedEmployee = this.getIndirectEmployeesForEmployeeWiseTasks.find(
      (emp: any) => emp.id === this.selectedEmpIdForEmpWiseTask
    );

    // Correct name handling
    if ((this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') && !this.loggedInUserRoleIsMD) {
      if (this.selectedEmpIdForEmpWiseTask === this.loggedInUserId) {
        selectedEmployeeName = 'My Chart';
      } else {
        selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
      }
    } else {
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
    }

    // Trigger PDF download
    this.pdfDownload.taskManagementGraphPDFdownload(
      null, // chartId
      'employeeWiseTasksTable', // tableId
      title, // Title
      formattedDate, // Date
      selectedEmployeeName || 'My Chart', // Employee name
      null // Task
    );
  }


  // taskManagementDashboardGraphDownloadEmpTaskWithExtention() {
  //   let title:any;
  //   let selectedEmployeeName:any
  //   if(this.loggedInUserRole != 'Employee'){
  //     title = 'Employee wise tasks with Extensions'
  //   }else{
  //     title = 'Tasks with Extensions'
  //   }
  //   const fromDate = this.datePipe.transform(this.employeeExtentionFromDate, 'dd-MM-yyyy');
  //   const toDate = this.datePipe.transform(this.employeeExtentionToDate, 'dd-MM-yyyy');
  //   const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

  //   const selectedEmployee = this.getIndirectEmployeesForEmployeeWiseTaskWithExtension.find((emp:any) => emp.id === this.selectedEmpIdForEmpWiseTaskWithExtention);
  //   if((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD){
  //     selectedEmployeeName = 'My Chart'
  //   }else {
  //      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
  //   }

  //   this.pdfDownload.taskManagementGraphPDFdownload(
  //     null, // chartId
  //     'tasksWithExtensionsTable', // tableId
  //     title, // Title
  //     formattedDate, // Date
  //     selectedEmployeeName || 'My Chart', // Employee name
  //     null, // Task
  //   );
  //   // if (this.employeeExtentionFromDate != null && this.employeeExtentionToDate != null) {
  //   //   const request = {
  //   //     "actionable": [],
  //   //     "companyId": this.loggedInUserCompanyID,
  //   //     "employeeId": [this.selectedEmpIdForEmpWiseTaskWithExtention],
  //   //     "fromDate": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
  //   //     "fromYear": null,
  //   //     "managerId": null,
  //   //     "month": null,
  //   //     "reportName": "EmployeewisetaskswithExtensions",
  //   //     "reportType": "table chart",
  //   //     "toDate": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
  //   //     "userId": null
  //   //   }
  //   //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
  //   //     if (data?.data != null) {
  //   //       var fileName = data?.data?.split(environment.downloadURL)
  //   //       saveAs(data?.data, fileName[1]);
  //   //     }
  //   //   })
  //   // }
  // }

  taskManagementDashboardGraphDownloadEmpTaskWithExtention() {
    let title: any;
    let selectedEmployeeName: any;

    // Set title
    title = this.loggedInUserRole !== 'Employee'
      ? 'Employee wise tasks with Extensions'
      : 'Tasks with Extensions';

    // Format date
    const fromDate = this.datePipe.transform(this.employeeExtentionFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.employeeExtentionToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    // Get selected employee
    const selectedEmployee = this.getIndirectEmployeesForEmployeeWiseTaskWithExtension.find(
      (emp: any) => emp.id === this.selectedEmpIdForEmpWiseTaskWithExtention
    );

    // Set correct employee name
    if ((this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD') && !this.loggedInUserRoleIsMD) {
      if (this.selectedEmpIdForEmpWiseTaskWithExtention === this.loggedInUserId) {
        selectedEmployeeName = 'My Chart';
      } else {
        selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
      }
    } else {
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
    }

    // Call download
    this.pdfDownload.taskManagementGraphPDFdownload(
      null, // chartId
      'tasksWithExtensionsTable', // tableId
      title, // Title
      formattedDate, // Date
      selectedEmployeeName || 'My Chart', // Employee name
      null // Task
    );
  }


  taskManagementDashboardGraphDownloadMyComingWeekTask() {
    const fromDate = this.datePipe.transform(this.myComingWeekTaskFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.myComingWeekTaskToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    this.pdfDownload.taskManagementGraphPDFdownload(
      null, // chartId
      'myComingWeekTaskTable', // tableId
      'My Coming Week Task', // Title
      formattedDate, // Date
      null, // Employee name
      null, // Task
    );

    // var id;
    // if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
    //   id = this.selectedEmpIdForDashboard;
    // }
    // if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
    //   id = this.loggedInUserId;
    // }
    // if (this.myComingWeekTaskFromDate != null && this.myComingWeekTaskToDate != null) {
    //   const request = {
    //     "actionable": [],
    //     "companyId": this.loggedInUserCompanyID,
    //     "employeeId": [id],
    //     "fromDate": this.datePipe.transform(this.myComingWeekTaskFromDate, 'yyyy-MM-dd'),
    //     "fromYear": null,
    //     "managerId": null,
    //     "month": null,
    //     "reportName": "MyComingWeekTask",
    //     "reportType": "table chart",
    //     "toDate": this.datePipe.transform(this.myComingWeekTaskToDate, 'yyyy-MM-dd'),
    //     "userId": null
    //   }
    //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
    // }
  }

  taskManagementDashboardGraphDownloadAllocatedWeekTask() {
    const fromDate = this.datePipe.transform(this.allocatedTaskFromDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.allocatedTaskToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    this.pdfDownload.taskManagementGraphPDFdownload(
      null, // chartId
      'allocatedTaskInTheWeekTable', // tableId
      'Allocated Task in The Week', // Title
      formattedDate, // Date
      null, // Employee name
      null, // Task
    );
    // var id;
    // if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin') {
    //   id = this.selectedEmpIdForDashboard;
    // }
    // if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
    //   id = this.loggedInUserId;
    // }
    // if (this.allocatedTaskFromDate != null && this.allocatedTaskToDate != null) {
    //   const request = {
    //     "actionable": [],
    //     "companyId": this.loggedInUserCompanyID,
    //     "employeeId": [],
    //     "fromDate": this.datePipe.transform(this.allocatedTaskFromDate, 'yyyy-MM-dd'),
    //     "fromYear": null,
    //     "managerId": id,
    //     "month": null,
    //     "reportName": "AllocatedTaskinTheWeek",
    //     "reportType": "table chart",
    //     "toDate": this.datePipe.transform(this.allocatedTaskToDate, 'yyyy-MM-dd'),
    //     "userId": null
    //   }
    //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
    //     if (data?.data != null) {
    //       var fileName = data?.data?.split(environment.downloadURL)
    //       saveAs(data?.data, fileName[1]);
    //     }
    //   })
    // }
  }

  // taskManagementDashboardGraphonDownloadDWMEmpWiseTaskStatus() {
  //   let title:any;
  //   let selectedEmployeeName:any
  //   if(this.loggedInUserRole != 'Employee'){
  //     title = 'Employee wise Task Status'
  //   }else{
  //     title = 'Task wise Status'
  //   }
  //   const fromDate = this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'dd-MM-yyyy');
  //   const toDate = this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'dd-MM-yyyy');
  //   const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

  //   const selectedEmployee = this.getIndirectEmployees.find((emp:any) => emp.id === this.selectedEmpIdForDWMEmpWiseTaskStatus);
  //   if((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD){
  //     selectedEmployeeName = 'My Chart'
  //   }else {
  //      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
  //   }

  //   this.pdfDownload.taskManagementGraphPDFdownload(
  //     null, // chartId
  //     'taskWiseStatusTable', // tableId
  //     title, // Title
  //     formattedDate, // Date
  //     selectedEmployeeName || 'My Chart', // Employee name
  //     this.selectedDWMTaskStatus ? this.selectedDWMTaskStatus: null, // Task
  //   );
  //   // var id;
  //   // if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Manager') {
  //   //   id = this.selectedEmpIdForDWMEmpWiseTaskStatus;
  //   // }
  //   // if (this.loggedInUserRole == 'Employee') {
  //   //   id = this.loggedInUserId;
  //   // }
  //   // if (this.dwmEmpWiseTaskStatusFormDate != null && this.dwmEmpWiseTaskStatusToDate != null) {
  //   //   const request = {
  //   //     "actionable": [this.selectedDWMTaskStatus],
  //   //     "companyId": this.loggedInUserCompanyID,
  //   //     "employeeId": [id],
  //   //     "fromDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'yyyy-MM-dd'),
  //   //     "fromYear": null,
  //   //     "managerId": null,
  //   //     "month": null,
  //   //     "reportName": "EmployeewiseTaskStatusDwm",
  //   //     "reportType": "table chart",
  //   //     "toDate": this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'yyyy-MM-dd'),
  //   //     "userId": null
  //   //   }
  //   //   this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
  //   //     if (data?.data != null) {
  //   //       var fileName = data?.data?.split(environment.downloadURL)
  //   //       saveAs(data?.data, fileName[1]);
  //   //     }
  //   //   })
  //   // }
  // }


  taskManagementDashboardGraphonDownloadDWMEmpWiseTaskStatus() {
    let title: any;
    let selectedEmployeeName: any;

    // Set title based on role
    title = this.loggedInUserRole !== 'Employee' ? 'Employee wise Task Status' : 'Task wise Status';

    // Format date range
    const fromDate = this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'dd-MM-yyyy');
    const toDate = this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate && toDate ? `${fromDate} - ${toDate}` : '';

    // Get selected employee object
    const selectedEmployee = this.getIndirectEmployees.find((emp: any) => emp.id === this.selectedEmpIdForDWMEmpWiseTaskStatus);

    // Handle name logic
    if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD) {
      if (this.selectedEmpIdForDWMEmpWiseTaskStatus === this.loggedInUserId) {
        selectedEmployeeName = 'My Chart';
      } else {
        selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
      }
    } else {
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
    }

    // Final download call
    this.pdfDownload.taskManagementGraphPDFdownload(
      null, // chartId
      'taskWiseStatusTable', // tableId
      title, // Title
      formattedDate, // Date
      selectedEmployeeName || 'My Chart', // Employee name
      this.selectedDWMTaskStatus ? this.selectedDWMTaskStatus : null, // Task
    );
  }


  taskManagementDashboardGraphononDownloadDWMTaskCompletionStatus() {
    let title: any;
    let selectedEmployeeName: any
    if (this.loggedInUserRole != 'Employee') {
      title = 'Employee-wise Task Completion Status'
    } else {
      title = 'Task Completion Status'
    }
    const fromDate = this.datePipe.transform(this.dwmCompletionStatusToDate, 'dd-MM-yyyy');
    const formattedDate = fromDate;

    const selectedEmployee = this.getIndirectEmployees.find((emp: any) => emp.id === this.selectedEmpIdForDWMEmpCompletionStatus);

    if ((this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') && !this.loggedInUserRoleIsMD) {
      if (this.selectedEmpIdForDWMEmpCompletionStatus === this.loggedInUserId) {
        selectedEmployeeName = 'My Chart';
      } else {
        selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
      }
    } else {
      selectedEmployeeName = selectedEmployee ? selectedEmployee.name : '';
    }

    this.pdfDownload.taskManagementGraphPDFdownload(
      'dwmCompletionsStatuss', // chartId
      null, // tableId
      title, // Title
      formattedDate, // Date
      selectedEmployeeName || 'My Chart', // Employee name
      null, // Task
    );
    // var id;
    // if (this.loggedInUserRole == 'Admin' || this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD') {
    //   id = this.selectedEmpIdForDWMEmpCompletionStatus;
    // }
    // if (this.loggedInUserRole == 'Employee') {
    //   id = this.loggedInUserId;
    // }
    // const request = {
    //   "actionable": [],
    //   "companyId": this.loggedInUserCompanyID,
    //   "employeeId": [id],
    //   "fromDate": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd'),
    //   "fromYear": null,
    //   "managerId": null,
    //   "month": null,
    //   "reportName": "EmployeewiseTaskCompletionStatusDwm",
    //   "reportType": "donut chart",
    //   "toDate": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd'),
    //   "userId": null
    // }
    // this.httpService.callPostService(this.config.taskManagementDashboardGraphDownload, request).subscribe((data: any) => {
    //   if (data?.data != null) {
    //     var fileName = data?.data?.split(environment.downloadURL)
    //     saveAs(data?.data, fileName[1]);
    //   }
    // })
  }
  getIndirectEmployeesForEmpWiseTaskStatus: any = [];
  getIndirectEmployeesForEmployeeWiseTasks: any = [];
  getIndirectEmployeesForEmployeeWiseTaskWithExtension: any = [];
  getIndirectEmployeewiseTaskStatusEmpListTaskStatus: any = [];
  getIndirectEmployeeTaskCompletionTaskStatus: any = [];

  employeeWiseTaskStatusEmpList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.employeeStatusFromDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.employeeStatusToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployeesForEmpWiseTaskStatus = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployeesForEmpWiseTaskStatus.push(obj);
      });
      this.getIndirectEmployeesForEmpWiseTaskStatus = this.getIndirectEmployeesForEmpWiseTaskStatus?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      //this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployeesForEmpWiseTaskStatus[0].id;
      }
    })
  }
  employeeWiseTasksEmpList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.employeeTaskFromDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.employeeTaskToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployeesForEmployeeWiseTasks = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployeesForEmployeeWiseTasks.push(obj);
      });
      this.getIndirectEmployeesForEmployeeWiseTasks = this.getIndirectEmployeesForEmployeeWiseTasks?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTask = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        if (this.getIndirectEmployeesForEmployeeWiseTasks.length != 0) {
          this.selectedEmpIdForEmpWiseTask = this.getIndirectEmployeesForEmployeeWiseTasks[0].id;
        } else {
          this.selectedEmpIdForEmpWiseTask = null
        }
      }
    })
  }
  employeeWiseTaskWithExtensionEmpList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.employeeExtentionFromDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.employeeExtentionToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployeesForEmployeeWiseTaskWithExtension = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployeesForEmployeeWiseTaskWithExtension.push(obj);
      });
      this.getIndirectEmployeesForEmployeeWiseTaskWithExtension = this.getIndirectEmployeesForEmployeeWiseTaskWithExtension?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      //this.selectedEmpIdForDashboard = this.getIndirectEmployees[0].id
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTaskWithExtention = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        if (this.getIndirectEmployeesForEmployeeWiseTasks.length != 0) {
          this.selectedEmpIdForEmpWiseTaskWithExtention = this.getIndirectEmployeesForEmployeeWiseTaskWithExtension[0].id;
        } else {
          this.selectedEmpIdForEmpWiseTaskWithExtention = null
        }
      }
    })
  }

  employeewiseTaskStatusEmpList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.dwmEmpWiseTaskStatusFormDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.dwmEmpWiseTaskStatusToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus.push(obj);
      });
      this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus = this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployeewiseTaskStatusEmpListTaskStatus[0].id;
      }
      this.getDWMTaskActionableList();
    })
  }

  employeewiseTaskCompletionStatusEmpList() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "date": null,
      "from": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd'),
      "fromYear": null,
      "to": this.datePipe.transform(this.dwmCompletionStatusToDate, 'yyyy-MM-dd'),
      "toYear": null,
      "userId": this.loggedInUserId,
      "userType": null,
      "yearRange": null
    }
    this.httpService.callPostService(this.config.getIndirectEmployeesfortaskManagement, request).subscribe((data: any) => {
      this.getIndirectEmployeeTaskCompletionTaskStatus = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele?.id,
          name: ele?.firstName + ' ' + ele?.lastName
        }
        this.getIndirectEmployeeTaskCompletionTaskStatus.push(obj);
      });
      this.getIndirectEmployeeTaskCompletionTaskStatus = this.getIndirectEmployeeTaskCompletionTaskStatus?.sort((a: any, b: any) => a.name.localeCompare(b.name))
      if (this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Employee') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.loggedInUserId;
      } else if (this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'Super Admin') {
        this.selectedEmpIdForEmpWiseTaskStatus = this.getIndirectEmployeeTaskCompletionTaskStatus[0].id;
      }
      this.onChangeEmpCompletionStatusByIdDate();
    })
  }
}
